export const featureArticles2026 = [
  {
    "id": "tesla-optimus-vs-figure-unitree-1x-neo",
    "slug": "tesla-optimus-vs-figure-unitree-1x-neo",
    "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo",
    "title": "Tesla Optimus vs Figure 03 vs Unitree G1 vs 1X NEO",
    "headline": "Tesla Optimus, Figure 03, Unitree G1 and 1X NEO Compared",
    "seoTitle": "Tesla Optimus vs Figure 03 vs Unitree G1 vs 1X NEO",
    "description": "A source-checked comparison of Optimus, Figure 03, Unitree G1 and 1X NEO covering hardware, autonomy, pricing, production and real deployments today.",
    "category": "Humanoid robot comparison",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "16 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "Tesla Optimus vs Figure vs Unitree vs 1X NEO",
    "keywords": [
      "Tesla Optimus vs Figure 03",
      "Unitree G1 vs 1X NEO",
      "humanoid robot comparison",
      "Figure 03 specifications",
      "Unitree G1 price",
      "1X NEO price",
      "humanoid robot autonomy",
      "humanoid robot production",
      "physical AI robots"
    ],
    "searchQuestions": [
      "Which humanoid robot is the most advanced?",
      "Can you buy Tesla Optimus?",
      "How much does Unitree G1 cost?",
      "Is 1X NEO autonomous?",
      "Has Figure deployed robots in factories?"
    ],
    "longTailKeywords": [
      "Tesla Optimus vs Figure 03 specifications",
      "Unitree G1 or 1X NEO for research",
      "best humanoid robot for industrial pilots",
      "humanoid robot available to buy in 2026"
    ],
    "entities": [
      "Tesla",
      "Figure AI",
      "Unitree Robotics",
      "1X Technologies",
      "BMW Group",
      "Helix",
      "Redwood AI"
    ],
    "introduction": [
      "Only one of these four robots has a public checkout price. Unitree lists the base G1 at $13,500 before tax and shipping. 1X accepts a $200 deposit for NEO and publishes a $20,000 Early Access ownership price or a monthly plan. Figure has delivered more than 350 Figure 03 units according to its own April 2026 production update, but does not sell the robot through a public store. Tesla describes Optimus as a general-purpose autonomous biped, yet still publishes no current product price, order page or complete specification sheet.",
      "That split matters more than a choreography video or a single manipulation clip. This comparison separates published hardware from missing data, autonomous execution from human assistance, production capacity from delivered units and a research platform from a consumer product. Each row refers to one named generation Figure 03, Unitree G1, the 2026 1X NEO product page and Tesla’s current Optimus program. Earlier Tesla prototypes and Figure 02 deployment results are discussed only when the generation is stated."
    ],
    "keyFindings": [
      "Unitree G1 is the easiest of the four to purchase for research because its base price, specifications and store channel are public.",
      "Figure has published the strongest quantified factory evidence Figure 02 logged 1,250 hours at BMW, while Figure 03 later entered a separate logistics workflow.",
      "1X NEO has the clearest home-commercial offer, but Early Access combines basic autonomy with scheduled Expert Mode and remote control.",
      "Tesla has the largest manufacturing ambition but the least complete public product sheet among the four compared here.",
      "No company has published a common benchmark that makes dexterity, task success or autonomy directly comparable across all four robots."
    ],
    "comparisonTables": [
      {
        "id": "four-humanoid-comparison",
        "title": "Four humanoid robots compared",
        "description": "“Not publicly disclosed” means the manufacturer did not publish a current value on the official pages reviewed on July 11, 2026.",
        "columns": [
          "Robot",
          "Body and mobility",
          "Hands and sensing",
          "Battery",
          "Autonomy evidence",
          "Price and availability"
        ],
        "rows": [
          [
            "Tesla Optimus",
            "Biped. Current height, mass, speed and payload are not consolidated in a current official product sheet.",
            "Tesla shows articulated hands and vision-led manipulation, but a current finger count, hand DOF and tactile specification are not published on its AI page.",
            "Not publicly disclosed.",
            "Autonomy is the program goal. Public clips do not provide a standard intervention log, success rate or continuous third-party evaluation.",
            "No public sale price, deposit or delivery program."
          ],
          [
            "Figure 03",
            "Third-generation biped. Figure says it has 9% less mass than Figure 02 but does not publish a complete current size and payload table.",
            "Palm cameras, compliant fingertips and company-developed tactile sensors that Figure says detect loads as small as three grams.",
            "2.3 kWh pack; Figure reports about five hours at peak use and 2 kW wireless charging.",
            "Helix 02 demonstrations are described by Figure as autonomous, including an uncut four-minute dishwasher sequence. Evidence remains company-produced.",
            "Enterprise channel only. Price not public. More than 350 units delivered according to Figure."
          ],
          [
            "Unitree G1",
            "1.32 m, about 35 kg, 23 DOF base or up to 43 DOF on EDU configurations. Depth camera and 3D LiDAR.",
            "Base model has no dexterous hand. EDU can use an optional 7-DOF three-finger Dex3-1 hand with optional tactile arrays.",
            "9,000 mAh quick-release battery; about two hours claimed runtime.",
            "Research platform with imitation and reinforcement-learning tooling. Many advertised example functions are explicitly marked as still in development.",
            "From $13,500 before tax and shipping. Public store and sales channel."
          ],
          [
            "1X NEO",
            "1.68 m, 30 kg. Official page lists 1.4 m/s walking, 6.2 m/s maximum running, 25 kg carry and 8 kg arm payload.",
            "Five-finger tendon-driven hands. The July 9, 2026 engineering article specifies 22 finger-and-palm DOF plus three wrist DOF, totaling 25.",
            "842 Wh; up to four hours claimed runtime; self-charging.",
            "Basic autonomy through Redwood AI, plus scheduled Expert Mode for remote human supervision and user-controlled remote operation.",
            "$20,000 Early Access ownership or $499 per month; $200 refundable deposit; initial U.S. deliveries in 2026."
          ]
        ],
        "note": "Manufacturer claims are not independent certification. Price, configuration and delivery terms can change after publication."
      }
    ],
    "sections": [
      {
        "heading": "The products are aimed at different buyers",
        "paragraphs": [
          "Unitree G1 is sold as a compact humanoid development platform. Its base configuration is inexpensive relative to full-size systems, but the lower price omits the dexterous hands and expanded compute expected in many manipulation projects. The EDU version adds secondary development access and optional hand configurations. A lab can buy the body, read the specifications and begin building its own control stack; it should not expect a finished general worker.",
          "Figure 03 is an enterprise fleet platform. Figure redesigned the robot for Helix, home-safe contact, inductive charging and higher-volume production. The company does not publish a retail price or self-service order process. Access is tied to commercial relationships, internal fleet development and selected deployments.",
          "NEO is positioned as a home product. The soft body, low mass, quiet operation, stereo cameras, mobile app and subscription structure reflect that target. Early owners are also joining a learning program 1X says the robot arrives with foundational autonomy and can use a scheduled human Expert for chores it cannot yet perform.",
          "Optimus remains a vertically integrated Tesla program rather than a purchasable product. Tesla’s official AI page describes the intended capability and the engineering disciplines behind it, but does not provide a buyer-facing configuration, warranty, delivery territory or price."
        ]
      },
      {
        "heading": "Autonomy cannot be inferred from smooth movement alone",
        "paragraphs": [
          "Figure provides the clearest description of end-to-end autonomous execution among the four. Helix 02 uses head cameras, palm cameras, tactile data and proprioception to control the full body. Figure describes its dishwasher demonstration as autonomous and uncut, without human intervention or resets. That supports an Autonomous classification for the specific filmed sequence, not every task Figure 03 can attempt.",
          "NEO should be classified task by task. Navigation, self-charging and known chores may run autonomously. Unknown or difficult chores can move into Human-in-the-loop or Teleoperated operation through Expert Mode or remote control. The visible result may look identical, so an honest caption must state which mode was used.",
          "Unitree supplies hardware and development interfaces. A G1 demonstration can be scripted, teleoperated, driven by a learned policy or autonomously executed by customer software. The robot model alone does not determine the control mode. Tesla says autonomy is the goal for Optimus, but its public media does not consistently disclose supervision, resets or intervention for each clip."
        ],
        "sources": [
          {
            "label": "Figure Helix 02",
            "url": "https://www.figure.ai/news/helix-02"
          },
          {
            "label": "1X NEO control modes",
            "url": "https://www.1x.tech/neo"
          },
          {
            "label": "Unitree G1 specifications",
            "url": "https://www.unitree.com/g1/"
          },
          {
            "label": "Tesla AI and Robotics",
            "url": "https://www.tesla.com/AI"
          }
        ]
      },
      {
        "heading": "Public deployment evidence favors Figure, while Unitree favors access",
        "paragraphs": [
          "Figure’s strongest operational record belongs to the retired Figure 02 generation. The company reports an 11-month BMW program, 1,250 runtime hours, more than 90,000 parts loaded and contribution to 30,000 X3 vehicles. Those are company-reported metrics from an active assembly line and should not be silently transferred to Figure 03. In June 2026, Figure separately showed Figure 03 handling parts and pulling a cart in a BMW logistics workflow.",
          "Unitree has broader open-market access and disclosed 2025 humanoid shipments above 5,500 units across its humanoid range. That shipment figure does not establish how many G1 units perform paid industrial work, nor does it show task success. It demonstrates manufacturing and customer delivery, a different kind of maturity.",
          "1X says NEO entered Early Access customer homes in 2026 and has opened a dedicated factory. Public evidence still needs household-scale reliability metrics intervention frequency, task duration, failure recovery and how often Experts are scheduled. Tesla has shown Optimus inside its own facilities, but has not published an equivalent externally auditable deployment table."
        ]
      },
      {
        "heading": "Recommendations by use case",
        "subsections": [
          {
            "heading": "Best for research Unitree G1 EDU",
            "paragraphs": [
              "The public price, compact 35 kg body, secondary-development option, LiDAR and camera stack make G1 the most accessible starting point. Budget for the EDU configuration, hands, compute, safety equipment and integration rather than comparing only the $13,500 base price."
            ]
          },
          {
            "heading": "Best for industrial pilots Figure 03",
            "paragraphs": [
              "Figure has manufacturing volume, a dedicated enterprise workflow and the most detailed published predecessor deployment. Access is selective and pricing is not public, so this recommendation is about pilot evidence rather than procurement simplicity."
            ]
          },
          {
            "heading": "Best for home ambitions 1X NEO",
            "paragraphs": [
              "NEO is the only one of the four sold with an explicit home offer, published ownership and subscription terms, a soft body and home-oriented assistance model. Early Access buyers must accept that some useful work will still require human supervision."
            ]
          },
          {
            "heading": "Most accessible to purchase Unitree G1",
            "paragraphs": [
              "G1 has a public base price and store channel. NEO also accepts orders, but its first deliveries are geographically limited and the $200 deposit is not the robot’s full price."
            ]
          },
          {
            "heading": "Strongest public evidence of deployment Figure",
            "paragraphs": [
              "Figure’s BMW reporting includes runtime, parts and vehicle-production figures. The evidence is still supplied by Figure and BMW rather than an independent audit, but it is more specific than a partnership announcement or a short factory clip."
            ]
          }
        ]
      }
    ],
    "limitations": [
      "Tesla does not publish a current Optimus product specification sheet, price, delivery schedule or task-level intervention logs.",
      "Figure does not publish a complete Figure 03 dimensions, weight and payload table. Figure 02 BMW results cannot be treated as Figure 03 results.",
      "Hand-only and hand-plus-wrist DOF are different counts. The July 2026 1X engineering article explains its 25-DOF total as 22 finger-and-palm axes plus three wrist axes.",
      "Company-produced videos do not provide a common test protocol, randomized environments or independent success-rate measurements.",
      "Production targets such as BotQ capacity or Tesla volume ambitions are not the same as units delivered to paying customers."
    ],
    "conclusion": [
      "There is no single winner because these robots are being sold, tested and measured in different ways. Unitree G1 is the practical choice for a lab that needs hardware now. Figure 03 has the strongest published industrial trajectory, supported by quantified Figure 02 work at BMW and a growing Figure 03 fleet. NEO is the clearest consumer proposition, with unusually detailed hardware and price information, but its useful-task model still includes scheduled human assistance. Optimus may eventually benefit from Tesla’s manufacturing and AI infrastructure, yet a buyer cannot currently compare it as a normal product because the essential commercial and technical fields remain unpublished.",
      "The most defensible comparison is therefore based on evidence type purchasability for Unitree, deployment documentation for Figure, home product design for 1X and manufacturing ambition for Tesla. Any ranking that ignores those different evidence levels turns four distinct programs into a misleading specification contest."
    ],
    "faqs": [
      {
        "question": "Can you buy Tesla Optimus in 2026?",
        "answer": "No public Tesla order page, full sale price or customer delivery program was available when this article was verified on July 11, 2026. Tesla describes Optimus as an autonomous general-purpose biped and recruits for production engineering, but those activities do not constitute a retail or enterprise sales offer."
      },
      {
        "question": "How much does Unitree G1 cost?",
        "answer": "Unitree lists the base G1 from $13,500, excluding tax and shipping. The research-oriented G1 EDU, dexterous hands, additional compute and support require a sales quotation. The base price should not be compared with a fully configured research system without listing the options."
      },
      {
        "question": "Is 1X NEO fully autonomous?",
        "answer": "1X says NEO works autonomously by default and arrives with basic autonomy. The same official page describes scheduled Expert Mode for chores the robot does not know and remote control through mobile and VR interfaces. Its correct classification therefore changes by task between autonomous, human-in-the-loop and teleoperated."
      },
      {
        "question": "Is Figure 03 already working at BMW?",
        "answer": "Figure published a June 2026 Figure 03 logistics workflow at BMW involving part handling and cart pulling. The older Figure 02 completed a separate 11-month body-shop deployment and was retired. Results from Figure 02 should not be presented as Figure 03 performance."
      },
      {
        "question": "Which robot has the best hands?",
        "answer": "No shared benchmark supports an absolute answer. Figure publishes sensitive tactile fingertips and palm cameras. NEO publishes high-DOF tendon-driven hands and strength data. Unitree offers optional three-finger force-controlled hands on G1 EDU. Tesla has not published a current hand specification detailed enough for the same comparison."
      },
      {
        "question": "Which robot is best for a university laboratory?",
        "answer": "Unitree G1 EDU is the most straightforward procurement option among these four because it exposes development interfaces and has a public base platform. A university should still evaluate fall protection, spare parts, hand options, compute, documentation, warranty and local technical support before purchase."
      }
    ],
    "methodology": "TechniaHQRobot reviewed manufacturer product pages, official technical announcements, order pages and deployment reports. Values are tied to the named generation. Company claims are described as claims when no independent audit is available. Missing fields were left undisclosed rather than inferred from older prototypes, conference slides or social-media commentary.",
    "sourceLinks": [
      {
        "label": "Tesla AI & Robotics",
        "url": "https://www.tesla.com/AI",
        "organization": "Tesla",
        "date": "Accessed July 11, 2026",
        "documentTitle": "AI & Robotics Tesla Optimus"
      },
      {
        "label": "Introducing Figure 03",
        "url": "https://www.figure.ai/news/introducing-figure-03",
        "organization": "Figure AI",
        "date": "October 9, 2025",
        "documentTitle": "Introducing Figure 03"
      },
      {
        "label": "Figure 03 battery development",
        "url": "https://www.figure.ai/news/f-03-battery-development",
        "organization": "Figure AI",
        "date": "2026",
        "documentTitle": "Figure 03 battery development"
      },
      {
        "label": "Ramping Figure 03 Production",
        "url": "https://www.figure.ai/news/ramping-figure-03-production",
        "organization": "Figure AI",
        "date": "April 29, 2026",
        "documentTitle": "Ramping Figure 03 Production"
      },
      {
        "label": "Figure 02 production at BMW",
        "url": "https://www.figure.ai/news/production-at-bmw",
        "organization": "Figure AI",
        "date": "November 19, 2025",
        "documentTitle": "Figure 02 production at BMW"
      },
      {
        "label": "Figure 03 at BMW",
        "url": "https://www.figure.ai/news/f-03-at-bmw",
        "organization": "Figure AI",
        "date": "June 30, 2026",
        "documentTitle": "Figure 03 at BMW"
      },
      {
        "label": "Unitree G1 product page",
        "url": "https://www.unitree.com/g1/",
        "organization": "Unitree Robotics",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Unitree G1 product page"
      },
      {
        "label": "Unitree official store",
        "url": "https://shop.unitree.com/products/unitree-g1",
        "organization": "Unitree Robotics",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Unitree official store"
      },
      {
        "label": "NEO product and specifications",
        "url": "https://www.1x.tech/neo",
        "organization": "1X Technologies",
        "date": "Accessed July 11, 2026",
        "documentTitle": "NEO product and specifications"
      },
      {
        "label": "NEO order terms",
        "url": "https://www.1x.tech/order",
        "organization": "1X Technologies",
        "date": "Accessed July 11, 2026",
        "documentTitle": "NEO order terms"
      },
      {
        "label": "NEO hands",
        "url": "https://www.1x.tech/discover/neos-hands",
        "organization": "1X Technologies",
        "date": "July 9, 2026",
        "documentTitle": "NEO hands"
      }
    ],
    "internalLinks": [
      {
        "label": "The cheapest humanoid robots with verified prices",
        "path": "/robotics-news/cheapest-humanoid-robots"
      },
      {
        "label": "How to tell autonomous robot demos from teleoperation",
        "path": "/robotics-news/autonomous-vs-teleoperated-robot-guide"
      },
      {
        "label": "16 humanoid robot hands compared",
        "path": "/robotics-news/humanoid-robot-hands-compared"
      },
      {
        "label": "Verified humanoid factory deployments",
        "path": "/robotics-news/humanoid-factory-deployments"
      },
      {
        "label": "20 humanoid robots you can actually buy in 2026",
        "path": "/robotics-news/20-humanoid-robots-you-can-actually-buy-2026"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "Four-panel comparison using official current-generation product photographs.",
        "alt": "Tesla Optimus, Figure 03, Unitree G1 and 1X NEO shown in four labeled panels",
        "source": "Tesla, Figure AI, Unitree and 1X official media pages",
        "sourceUrl": "https://www.figure.ai/news/introducing-figure-03"
      },
      {
        "type": "Secondary image",
        "caption": "Figure 03 hardware and soft-goods product view.",
        "alt": "Figure 03 humanoid robot standing against the official Figure product background",
        "source": "Figure AI",
        "sourceUrl": "https://www.figure.ai/news/introducing-figure-03"
      },
      {
        "type": "Secondary image",
        "caption": "Unitree G1 in the manufacturer product configuration.",
        "alt": "Unitree G1 compact humanoid robot in an official product photograph",
        "source": "Unitree Robotics",
        "sourceUrl": "https://www.unitree.com/g1/"
      },
      {
        "type": "Secondary image",
        "caption": "1X NEO inside a real home environment.",
        "alt": "1X NEO soft-bodied humanoid robot performing a household task",
        "source": "1X Technologies",
        "sourceUrl": "https://www.1x.tech/neo"
      },
      {
        "type": "Original table graphic",
        "caption": "Evidence matrix public price, production disclosure, deployment metrics and human assistance.",
        "alt": "Matrix comparing the commercial evidence available for four humanoid robots",
        "source": "TechniaHQRobot original chart using cited data",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "Unitree’s $13,500 G1 base price and published specifications were checked on its official product page.",
        "1X ownership, subscription and deposit terms were checked on the official order page.",
        "Figure’s 350-plus delivered units and one-per-hour production cycle are company-reported figures from April 2026.",
        "Figure 02 and Figure 03 BMW activities are separated by generation."
      ],
      "unconfirmed": [
        "Tesla’s current per-unit production volume, complete specification and sale price are not public.",
        "No independent cross-platform benchmark verifies the companies’ relative dexterity or general autonomy.",
        "This comparison does not independently verify the configuration or performance of every delivered NEO unit."
      ],
      "fastChanging": [
        "Prices, deposits, delivery territories, fleet totals and software capability claims can change within weeks."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "autonomous-vs-teleoperated-robot-guide",
    "slug": "autonomous-vs-teleoperated-robot-guide",
    "path": "/robotics-news/autonomous-vs-teleoperated-robot-guide",
    "title": "Is This Robot Autonomous or Teleoperated?",
    "headline": "Is This Robot Autonomous or Teleoperated? A Video Evidence Guide",
    "seoTitle": "Autonomous or Teleoperated? How to Read Robot Demos",
    "description": "A practical guide for classifying robot videos using visible evidence, autonomy categories, teleoperation signals and a reusable scoring grid for current demos.",
    "category": "Robot autonomy guide",
    "datePublished": "2026-07-11",
    "dateModified": "2026-07-11",
    "readingTime": "15 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "autonomous vs teleoperated robot",
    "keywords": [
      "robot teleoperation",
      "robot autonomy",
      "humanoid robot demo analysis",
      "human in the loop robotics",
      "shared autonomy",
      "VLA robot policy",
      "imitation learning",
      "scripted robot motion"
    ],
    "searchQuestions": [
      "How can you tell if a robot is teleoperated?",
      "What is shared autonomy?",
      "Does imitation learning mean teleoperation?",
      "Can a video prove robot autonomy?",
      "What is human-in-the-loop robotics?"
    ],
    "longTailKeywords": [
      "signs a humanoid robot video is teleoperated",
      "autonomous robot demo verification checklist",
      "difference between data collection and autonomous execution"
    ],
    "entities": [
      "teleoperation",
      "imitation learning",
      "shared autonomy",
      "reinforcement learning",
      "vision-language-action policy",
      "motion capture"
    ],
    "introduction": [
      "A robot can complete the same visible task through at least five different control paths. A person may drive every joint through a VR headset. A learned policy may execute a trajectory collected from human demonstrations. A supervisor may intervene only after a failed grasp. The motion may be a fixed script triggered by a button. A vision-language-action model may close the loop from camera images to motor commands. The finished clip can look equally smooth in every case.",
      "The useful question is therefore not whether the movement looks human. It is what information entered the system, who selected each action, when a human could intervene and whether the robot recovered from changes it did not see during training. This guide provides a repeatable classification, visible warning signs and a scoring grid. It also sets a hard limit a short edited video rarely proves autonomy by itself. Good reporting must combine the footage with a method statement, control interface, intervention log and task conditions."
    ],
    "keyFindings": [
      "Smooth motion is not evidence of autonomy; direct teleoperation can be low-latency and visually natural.",
      "Training data collected by teleoperation can later produce autonomous execution. The collection method and execution method must be reported separately.",
      "Cuts, speed changes and prepared objects reduce the evidentiary value of a demo, but do not prove deception.",
      "A human supervisor who approves plans or recovers failures creates a human-in-the-loop or supervised-autonomous system, not pure autonomy.",
      "The strongest evidence is a continuous run with disclosed inputs, intervention count, resets, task duration and failures."
    ],
    "comparisonTables": [
      {
        "id": "autonomy-classification-grid",
        "title": "Robot demo classification grid",
        "description": "Use the narrowest category supported by the available evidence. Do not upgrade a classification because the company uses the word AI.",
        "columns": [
          "Category",
          "Who chooses the action?",
          "Typical evidence",
          "Correct reporting language"
        ],
        "rows": [
          [
            "Autonomous",
            "The robot policy perceives, plans and executes without human action selection during the evaluated run.",
            "Uncut run, disclosed sensors, zero interventions, recovery behavior, task metrics.",
            "The robot completed this specific run autonomously under the stated conditions."
          ],
          [
            "Supervised autonomous",
            "The robot acts independently while a human monitors and can stop, approve or redirect.",
            "Supervisor console, approval gates, remote safety operator, intervention log.",
            "The robot operated autonomously under human supervision."
          ],
          [
            "Human-in-the-loop",
            "Human input enters the task during execution, often at uncertain points or failures.",
            "Remote assistance, corrections, escalations, handoff between policy and operator.",
            "The task combined autonomous execution with human assistance."
          ],
          [
            "Teleoperated",
            "A human continuously selects motion or end-effector commands.",
            "VR headset, motion-capture suit, gloves, joystick, mirrored movement, operator station.",
            "A human operator controlled the robot remotely."
          ],
          [
            "Scripted or pre-programmed",
            "A fixed sequence or trajectory determines the motion.",
            "Identical repetition, known coordinates, no perception-led adaptation, trigger-based routine.",
            "The robot executed a pre-programmed routine."
          ],
          [
            "Simulation only",
            "A controller runs in a virtual environment, not on the physical robot shown in the claim.",
            "Simulator interface, rendered environment, no physical hardware validation.",
            "The policy was evaluated in simulation only."
          ],
          [
            "Autonomy not disclosed",
            "The publisher does not state the control mode.",
            "Polished video without method notes or operator information.",
            "The control method was not disclosed."
          ],
          [
            "Insufficient evidence",
            "Evidence conflicts or is too incomplete to classify.",
            "Edited fragments, missing context, ambiguous overlays, no primary source.",
            "Available footage is insufficient to determine the control mode."
          ]
        ],
        "note": "A single project can use several categories teleoperation for data collection, autonomous execution for evaluation and human-in-the-loop recovery during deployment."
      },
      {
        "id": "video-evidence-scorecard",
        "title": "A 20-point evidence scorecard for readers",
        "columns": [
          "Evidence item",
          "0 points",
          "1 point",
          "2 points"
        ],
        "rows": [
          [
            "Continuity",
            "Heavy edits or montage",
            "Mostly continuous with minor cuts",
            "Full uncut task"
          ],
          [
            "Control disclosure",
            "No statement",
            "General statement only",
            "Exact interface and human role"
          ],
          [
            "Interventions",
            "Not reported",
            "Says none or few without count",
            "Count, timing and reason published"
          ],
          [
            "Environment",
            "Staged and fixed",
            "Some variation",
            "Multiple unfamiliar or randomized layouts"
          ],
          [
            "Error recovery",
            "Failures removed",
            "One recovery shown",
            "Repeated recoveries and failure cases"
          ],
          [
            "Task metrics",
            "No duration or success rate",
            "Selected metrics",
            "Trials, denominator, success and time"
          ],
          [
            "Sensor disclosure",
            "Unknown",
            "Sensor list only",
            "Sensor inputs linked to policy"
          ],
          [
            "Human equipment",
            "Off-camera area hidden",
            "Partial workstation view",
            "Operator area and interfaces shown"
          ],
          [
            "Speed",
            "Unknown acceleration",
            "Speed multiplier labeled",
            "Real-time sequence"
          ],
          [
            "Independent access",
            "Company video only",
            "Partner confirmation",
            "Third-party repeat or customer evidence"
          ]
        ],
        "note": "The score measures transparency, not robot quality. A low score means the video cannot carry a strong autonomy claim."
      }
    ],
    "sections": [
      {
        "heading": "Direct teleoperation has recognizable hardware, but it can also be hidden",
        "paragraphs": [
          "The clearest teleoperation setups use a VR headset for viewpoint, hand controllers or gloves for arm and finger pose, and a motion-capture system for the upper body. Some systems map a human’s joint positions directly to the robot. Others convert the operator’s motion into end-effector targets while a controller handles balance and collision limits. The second case is still teleoperation because the human continuously chooses the task motion, even though low-level stabilization is automatic.",
          "Look for synchronized starts, pauses and corrections between a person and robot. A delayed copy of the operator’s wrist rotation, elbow movement or grasp is strong evidence. A robot that freezes whenever the operator freezes is another clue. Joysticks and gamepads often produce more segmented translation and rotation, although experienced operators can make them look smooth.",
          "The operator may be in another room or another country. Absence from the frame proves nothing. Product pages that mention remote experts, supervision stations, fleet operations or recovery services should be read closely because those systems may deliberately combine autonomy with human support."
        ]
      },
      {
        "heading": "Imitation learning separates demonstration from execution",
        "paragraphs": [
          "Teleoperation is commonly used to collect training data. The operator opens a drawer, folds a towel or loads a dishwasher while cameras, joint positions and forces are recorded. A policy is then trained to predict actions from observations. When the trained policy later controls the robot without live human commands, that evaluation run can be autonomous even though every training example came from teleoperation.",
          "Google DeepMind’s ALOHA work follows this pattern human demonstrations teach a bimanual platform, after which learned policies execute tasks. Physical Intelligence similarly trains generalist policies from robot data and evaluates them through autonomous rollouts. The correct caption should say both things demonstrations were collected through teleoperation, and the published evaluation was autonomous under the stated setup.",
          "Data collection footage is often mislabeled as a capability demo. Gloves, leader arms or motion capture may show how examples are generated, not how the final policy runs. Check the video title, paper methods and timeline before classifying it."
        ]
      },
      {
        "heading": "Shared autonomy and human-in-the-loop systems divide the task",
        "paragraphs": [
          "Shared autonomy means the human supplies intent while the robot handles part of the execution. An operator may point to an object and let the robot plan the grasp. A person may drive the mobile base while autonomous collision avoidance controls local motion. A language command may select a goal while a manipulation policy decides joint actions.",
          "Human-in-the-loop is broader. It includes approval before a risky action, corrections during a task, escalation after a confidence threshold and remote recovery from failure. This architecture can be commercially sensible because it keeps a deployment running while autonomous coverage improves. It should not be described as autonomous without the qualifier.",
          "Supervised autonomous is appropriate when a robot normally acts on its own but a human continuously monitors safety or operations. The difference from human-in-the-loop is whether human input actually changes the evaluated run. Publishers should report both the availability of intervention and the number of interventions used."
        ]
      },
      {
        "heading": "Scripted movement, reinforcement learning and VLA policies solve different problems",
        "subsections": [
          {
            "heading": "Scripted motion",
            "paragraphs": [
              "A pre-programmed trajectory can be impressive and technically demanding, especially for dynamic locomotion. It does not require the robot to identify a changed object or choose a new plan. Exact repetition, fixed foot locations and failure after a small scene change are common signs."
            ]
          },
          {
            "heading": "Reinforcement-learning policy",
            "paragraphs": [
              "A reinforcement-learning controller may learn balance, locomotion or manipulation through rewards in simulation or on hardware. During deployment the policy can be autonomous, but a joystick may still provide desired velocity or heading. Report the learned layer and the human command layer separately."
            ]
          },
          {
            "heading": "Vision-language-action policy",
            "paragraphs": [
              "A VLA model consumes images and a language instruction, then outputs robot actions or action chunks. That architecture supports closed-loop autonomy, but the label VLA does not prove the shown run lacked operator corrections, safety approvals or resets."
            ]
          },
          {
            "heading": "World model and planner",
            "paragraphs": [
              "A world model predicts possible future states. A planner may use those predictions to choose actions, while a separate low-level controller executes them. Some projects call the complete stack a model; others disclose each component. Classification should follow the actual action-selection path."
            ]
          }
        ]
      },
      {
        "heading": "Visible clues that lower confidence in an autonomy claim",
        "paragraphs": [
          "Frequent cuts can remove failures, resets and human repositioning. Speed-up can conceal a 20-minute manipulation sequence or make pauses disappear. Neither practice is automatically deceptive when clearly labeled, but both prevent timing and continuity claims.",
          "Prepared environments reduce variation. Objects may be placed inside a narrow grasp region, drawers may be left partially open and visual markers may simplify localization. Repeating the same task with the same object pose does not test generalization. A stronger demo randomizes the scene and reports how many trials failed.",
          "Rigid trajectories, no reaction to a displaced object and identical timing across repetitions suggest a script. A robot that never attempts recovery may have had failed trials edited out, or its controller may simply stop on uncertainty. Commands spoken in a video do not prove speech caused the action; the audio may be a trigger, a later overlay or a genuine language input. The method statement must decide."
        ]
      }
    ],
    "limitations": [
      "A video cannot reveal an operator who is outside the frame or connected remotely.",
      "Latency varies with network, controller and filtering, so visible delay is not a reliable standalone test.",
      "A learned policy can repeat trajectories consistently; repetition alone does not prove scripting.",
      "An uncut video can still use prepared object poses, hidden initialization and human approval before recording starts.",
      "“Autonomous” can describe navigation while manipulation remains teleoperated, so each subsystem and task phase must be classified."
    ],
    "conclusion": [
      "The safest classification follows the action path, not the marketing label. Identify the sensor inputs, find who selected the goal, determine who selected the motion and record whether a human intervened. Teleoperation means the person continuously drives the action. Human-in-the-loop means human decisions enter during execution. Supervised autonomy means the robot acts while a person monitors. Scripted motion follows a fixed routine. Autonomous execution requires the robot to close the loop through perception and action for the evaluated run.",
      "When those facts are missing, “autonomy not disclosed” is more accurate than guessing. A transparent company should be able to state the run length, edits, speed, number of trials, resets, interventions, data-collection method and evaluation environment. That information turns a compelling clip into usable technical evidence."
    ],
    "faqs": [
      {
        "question": "How can I tell if a humanoid robot is teleoperated?",
        "answer": "Look for VR headsets, motion-capture suits, gloves, leader arms, joysticks and movements synchronized with a person. Also search the official project page for words such as teleoperation, expert, remote supervision or data collection. None of these clues alone proves the published task was teleoperated, because the same equipment may have been used only for training data."
      },
      {
        "question": "Does an uncut video prove autonomy?",
        "answer": "No. An uncut video is stronger than a montage because it preserves duration, pauses and visible failures. It still may begin after human setup, use a prepared environment or receive remote commands. Control disclosure and intervention reporting are required before the run can be classified confidently."
      },
      {
        "question": "Is imitation learning the same as teleoperation?",
        "answer": "No. Teleoperation is a control method in which a human drives the robot. Imitation learning is a training method that learns from demonstrations, often collected through teleoperation. A trained imitation policy can later execute a task autonomously, with human supervision or with live assistance depending on the deployment."
      },
      {
        "question": "What is shared autonomy in robotics?",
        "answer": "Shared autonomy divides control between a human and the robot. A person may choose the object, goal or direction while the robot plans a collision-free path, stabilizes the body or executes the grasp. Reporting should specify exactly which decisions came from the person and which came from the autonomous controller."
      },
      {
        "question": "Can a robot be autonomous if a safety operator is present?",
        "answer": "Yes, for a specific run, provided the safety operator does not select actions or intervene. The precise label is often supervised autonomous because a human is monitoring and can stop the system. The publication should report whether any intervention occurred and what would trigger one."
      },
      {
        "question": "What evidence is strongest for an autonomy claim?",
        "answer": "The strongest package combines continuous real-time video, randomized task conditions, disclosed sensor and policy inputs, trial counts, success rate, duration, intervention and reset logs, failure examples and a clear separation between training data collection and evaluation. Independent repetition by a customer or laboratory adds further confidence."
      }
    ],
    "methodology": "The guide uses a control-responsibility test who chooses the goal, who chooses each action and when a human can change the run. Definitions were checked against official robotics demonstrations and model documentation. The scorecard measures disclosure quality, not the underlying robot’s intelligence or commercial value.",
    "sourceLinks": [
      {
        "label": "NEO product and Expert Mode",
        "url": "https://www.1x.tech/neo",
        "organization": "1X Technologies",
        "date": "Accessed July 11, 2026",
        "documentTitle": "NEO product and Expert Mode"
      },
      {
        "label": "Helix 02 full-body autonomy",
        "url": "https://www.figure.ai/news/helix-02",
        "organization": "Figure AI",
        "date": "January 27, 2026",
        "documentTitle": "Helix 02 full-body autonomy"
      },
      {
        "label": "Advances in robot dexterity",
        "url": "https://deepmind.google/blog/advances-in-robot-dexterity/",
        "organization": "Google DeepMind",
        "date": "September 12, 2024",
        "documentTitle": "Advances in robot dexterity"
      },
      {
        "label": "Open X-Embodiment repository",
        "url": "https://github.com/google-deepmind/open_x_embodiment",
        "organization": "Google DeepMind",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Open X-Embodiment repository"
      },
      {
        "label": "π0 generalist policy",
        "url": "https://physicalintelligence.company/blog/pi0",
        "organization": "Physical Intelligence",
        "date": "October 31, 2024",
        "documentTitle": "π0 generalist policy"
      },
      {
        "label": "OpenVLA repository",
        "url": "https://github.com/openvla/openvla",
        "organization": "OpenVLA team",
        "date": "Accessed July 11, 2026",
        "documentTitle": "OpenVLA repository"
      },
      {
        "label": "RT-2 vision-language-action model",
        "url": "https://deepmind.google/blog/rt-2-new-model-translates-vision-and-language-into-action/",
        "organization": "Google DeepMind",
        "date": "July 28, 2023",
        "documentTitle": "RT-2 vision-language-action model"
      }
    ],
    "internalLinks": [
      {
        "label": "Humanoid factory deployments classified by evidence",
        "path": "/robotics-news/humanoid-factory-deployments"
      },
      {
        "label": "What home robots can actually do in 2026",
        "path": "/robotics-news/what-home-robots-can-do"
      },
      {
        "label": "The complete Physical AI model map",
        "path": "/robotics-news/physical-ai-model-map"
      },
      {
        "label": "Tesla, Figure, Unitree and 1X compared",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "Split-screen showing a teleoperation station and a robot executing alone.",
        "alt": "Robot operator wearing a VR headset beside a separate autonomous robot demonstration",
        "source": "Official manufacturer and laboratory media",
        "sourceUrl": "https://deepmind.google/blog/advances-in-robot-dexterity/"
      },
      {
        "type": "Secondary image",
        "caption": "ALOHA demonstration collection hardware.",
        "alt": "Human operator using a bimanual leader setup to demonstrate a robot task",
        "source": "Google DeepMind",
        "sourceUrl": "https://deepmind.google/blog/advances-in-robot-dexterity/"
      },
      {
        "type": "Secondary image",
        "caption": "NEO Expert Mode disclosure and home robot view.",
        "alt": "1X NEO in a home with the official Expert Mode description",
        "source": "1X Technologies",
        "sourceUrl": "https://www.1x.tech/neo"
      },
      {
        "type": "Original graphic",
        "caption": "Action-responsibility flowchart from human command to motor output.",
        "alt": "Decision tree for classifying autonomous, supervised, human-in-the-loop and teleoperated robots",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      },
      {
        "type": "Original table",
        "caption": "20-point transparency scorecard formatted for mobile.",
        "alt": "Robot demo evidence scorecard with ten two-point criteria",
        "source": "TechniaHQRobot original table",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "The classification definitions distinguish action selection from training-data collection.",
        "Examples link to primary project pages rather than social reposts.",
        "The article does not classify an unidentified video without supporting method information."
      ],
      "unconfirmed": [
        "A viewer cannot detect all remote intervention from pixels alone.",
        "Companies use the word autonomous with different subsystem boundaries and evaluation conditions."
      ],
      "fastChanging": [
        "Robot fleet supervision tools and intervention policies change as software is updated."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "humanoid-robot-hands-compared",
    "slug": "humanoid-robot-hands-compared",
    "path": "/robotics-news/humanoid-robot-hands-compared",
    "title": "16 Humanoid Robot Hands Compared",
    "headline": "16 Humanoid Robot Hands Compared DOF, Sensing and Evidence",
    "seoTitle": "16 Humanoid Robot Hands Compared Sensing and DOF in 2026",
    "description": "Sixteen humanoid robot hands compared by fingers, degrees of freedom, actuation, tactile sensing, force control, demonstrated tasks and availability in 2026.",
    "category": "Humanoid robot hands",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "18 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "humanoid robot hands compared",
    "keywords": [
      "robot hand degrees of freedom",
      "dexterous robotic hand",
      "humanoid hand tactile sensors",
      "Figure 03 hand",
      "1X NEO hand",
      "Unitree Dex3-1",
      "Sharpa Wave hand",
      "Shadow Dexterous Hand"
    ],
    "searchQuestions": [
      "Which humanoid robot has the best hand?",
      "How many DOF does a robot hand need?",
      "Do humanoid hands have touch sensors?",
      "Can researchers buy a dexterous robot hand?"
    ],
    "longTailKeywords": [
      "five finger humanoid robot hands with tactile sensors",
      "best documented robot hand for embodied AI research",
      "humanoid hand DOF comparison 2026"
    ],
    "entities": [
      "1X NEO",
      "Figure 03",
      "Unitree Dex3-1",
      "Sharpa Wave",
      "Shadow Dexterous Hand",
      "iCub",
      "Fourier GR-2",
      "Sanctuary Phoenix"
    ],
    "introduction": [
      "A five-finger silhouette says almost nothing about a robot hand’s useful capability. One hand may have 22 independently driven degrees of freedom and dense fingertip touch. Another may use five fingers coupled to six motors. A three-finger hand can outperform both in repetitive industrial picking because it is lighter, simpler and easier to control. Published specifications also use incompatible counting rules some companies report joints, some active degrees of freedom, some total hand-and-wrist axes and some only the number of actuators.",
      "This comparison covers sixteen hands built for humanoid robots, humanoid upper bodies or direct integration into humanoid research platforms. It excludes parallel grippers and purely cosmetic hands. The table records only values found in manufacturer pages, technical reports or laboratory documentation. Missing fields remain missing. The categories at the end are evidence-based groupings, not a universal ranking, because no common protocol measures fingertip force, in-hand manipulation, tactile resolution, durability and task success across all sixteen systems."
    ],
    "keyFindings": [
      "Sharpa Wave and Shadow publish the most detailed standalone commercial hand specifications in this set.",
      "Figure 03 and 1X NEO integrate vision or whole-body design decisions that cannot be judged from finger count alone.",
      "Three-finger systems such as Unitree Dex3-1 trade human-like morphology for lower mass and simpler control.",
      "Tactile sensing ranges from a few contact or pressure sensors to dense arrays with more than 1,000 pixels per fingertip.",
      "Several major humanoid companies do not publish enough hand data for a defensible dexterity ranking."
    ],
    "comparisonTables": [
      {
        "id": "sixteen-humanoid-hands",
        "title": "Sixteen humanoid and humanoid-platform hands",
        "description": "Active DOF and joint counts are kept separate where the source distinguishes them. “Undisclosed” is preferable to inferring mechanics from appearance.",
        "columns": [
          "Hand / robot",
          "Country",
          "Fingers and DOF",
          "Actuation and sensing",
          "Documented task or status"
        ],
        "rows": [
          [
            "1X NEO hand",
            "United States / Norway origin",
            "Five fingers; 1X's July 2026 dedicated hand release specifies 25 DoF including three wrist axes and 22 fully actuated finger-and-palm DoF.",
            "Tendon-driven, low-inertia, IP68 hand. Published joint torque and durability figures; cameras are in NEO’s head rather than palm.",
            "Integrated into NEO. Home manipulation and fast finger motion shown. Early Access product."
          ],
          [
            "Figure 03 hand",
            "United States",
            "Five fingers; active DOF count not publicly disclosed.",
            "Compliant fingertips, custom tactile sensors that Figure says detect loads as small as three grams, and an embedded palm camera.",
            "Dishwasher loading, bedroom reset and industrial part handling under Helix demonstrations. Not sold separately."
          ],
          [
            "Unitree Dex3-1",
            "China",
            "Three fingers, 7 active DOF thumb 3, index 2, middle 2.",
            "Force-position hybrid control; optional tactile sensor arrays. About 710 g on Unitree product documentation.",
            "Optional on G1 EDU and other Unitree platforms. Commercial sales channel."
          ],
          [
            "Unitree Dex5-1",
            "China",
            "Five fingers; exact current DOF requires configuration confirmation.",
            "Manufacturer presents it as a five-finger dexterous hand; public detailed specification is less complete than Dex3-1.",
            "Offered in Unitree’s current hand catalog. Ranking withheld because sensing and force data are incomplete."
          ],
          [
            "Sharpa Wave",
            "Singapore / China manufacturing",
            "Five fingers, 22 active DOF.",
            "Joint-space actuation, Dynamic Tactile Array, over 1,000 tactile pixels per fingertip, claimed 0.02 N sensitivity and over 20 N fingertip force.",
            "Shipping standalone hand; integrated into Sharpa North and NVIDIA’s H2-based reference humanoid."
          ],
          [
            "Shadow Dexterous Hand",
            "United Kingdom",
            "Five fingers, 20 actuated DOF and 24 joints including wrist/palm coupling.",
            "Tendon-driven, EtherCAT/ROS, more than 100 sensors; optional expanded fingertip tactile sensing.",
            "Commercial research hand used on humanoid and arm platforms. Published 4 kg power-grasp rating in 2025 specification."
          ],
          [
            "Fourier GR-2 dexterous hand",
            "Singapore / China",
            "Five fingers, 12 DOF per hand on the enhanced configuration.",
            "Six array tactile sensors; force and material sensing described by Fourier.",
            "Integrated into GR-2 for manipulation research and demonstrations. Quote-based platform."
          ],
          [
            "Sanctuary Phoenix hand",
            "Canada",
            "Five fingers; Gen 6 described 20 total hand DOF, later hydraulic hand releases use different generations.",
            "Hydraulic actuation, proprietary haptics and new tactile sensors. Generation must be stated.",
            "In-hand manipulation and industrial task research. Current standalone availability not public."
          ],
          [
            "iCub hand",
            "Italy",
            "Five fingers; 9 motors and 19 joints in the hand, plus a 3-DOF wrist in catalog documentation.",
            "Tendon-driven; tactile skin on palm and fingertips, encoders and force/torque sensing in the platform.",
            "Long-running open research platform for grasping, learning and human-robot interaction."
          ],
          [
            "IIT R1 hand",
            "Italy",
            "Five fingers, 4 DOF hand.",
            "Series-elastic actuation and distributed pressure sensing; designed for safe service manipulation.",
            "Integrated into R1 research humanoid. Not a high-DOF in-hand manipulation system."
          ],
          [
            "DLR Hand II",
            "Germany",
            "Four fingers, three DOF per finger plus one reconfigurable palm DOF.",
            "Integrated motors, joint torque, position, motor-position and temperature sensors.",
            "Used on Rollin’ Justin and Agile Justin for bimanual research. Historical research hardware."
          ],
          [
            "DLR-HIT Hand II",
            "Germany / China",
            "Five modular fingers, 15 DOF and four joints per finger with distal coupling.",
            "Integrated brushless motors, harmonic drives, position, force/torque and temperature sensing.",
            "Used on SpaceJustin with shared autonomy. Research platform rather than current mass-market product."
          ],
          [
            "Toyota T-HR3 hand",
            "Japan",
            "Five-finger humanoid hand; detailed active hand DOF not separately published in the reviewed corporate material.",
            "Torque Servo modules and master maneuvering system for remote operation.",
            "Teleoperated fine hand and arm movements in partner-robot research. Not commercially offered."
          ],
          [
            "UBTECH Walker S2 hand",
            "China",
            "Five-finger industrial dexterous hand; current public product page does not provide a clean hand-only DOF table.",
            "UBTECH reports successive fourth- and fifth-generation dexterous hand development; sensing detail varies by corporate report.",
            "Integrated into mass-produced Walker S2 factory platform. Information insufficient for rank."
          ],
          [
            "Apptronik Apollo hand",
            "United States",
            "Five-finger appearance; current public active DOF and tactile specification not disclosed.",
            "Apptronik describes dexterous manipulation but does not publish a complete hand data sheet.",
            "Industrial pilot platform. Information insufficient for hand ranking."
          ],
          [
            "AgiBot G-series dexterous hand",
            "China",
            "Multi-finger dexterous hand; model-specific public DOF and sensor fields are incomplete on English product pages.",
            "Integrated actuation and embodied-AI manipulation stack; generation-specific technical sheet not located.",
            "Used across AgiBot full-size and industrial platforms. Information insufficient for rank."
          ]
        ],
        "note": "The table does not equate high DOF with task reliability. Control software, calibration, compliance, tactile feedback, wrist design and training data can dominate real performance."
      }
    ],
    "sections": [
      {
        "heading": "Degrees of freedom are useful only when the counting method is clear",
        "paragraphs": [
          "A human hand contains many anatomical joints, but robotic designs often mechanically couple distal joints or drive several joints from one tendon. A specification may therefore list 24 joints and 20 controllable degrees of freedom. Another company may add two wrist axes to the hand total. The comparison should preserve the manufacturer’s terms rather than normalize them into a false single number.",
          "Independent actuation supports more hand shapes and in-hand manipulation, but increases motor count, wiring, calibration and control complexity. Coupled fingers can produce robust enveloping grasps with fewer actuators. Industrial reliability may favor fewer degrees of freedom when the task is carrying a tote, feeding a part or pressing a button.",
          "Three-finger hands deserve separate consideration. Unitree Dex3-1 does not imitate human anatomy, yet its seven active axes and optional tactile arrays can cover pinch, tripod and power grasps at much lower mass than many five-finger systems. It should not be mislabeled as a five-finger hand or compared on appearance."
        ]
      },
      {
        "heading": "Touch sensing is not one feature",
        "paragraphs": [
          "A pressure switch can confirm contact. A strain gauge can estimate joint torque. A force/torque sensor can measure the wrench at a wrist or fingertip. Dense tactile arrays can localize pressure across a surface and detect slip patterns. Companies frequently use the word tactile for all of these systems, so the sensor type and location matter.",
          "Figure publishes a clear threshold claim for its fingertip sensor and adds palm cameras to preserve close-range vision when the head view is occluded. Sharpa publishes tactile pixel density and pressure sensitivity. Shadow publishes a broad sensor count and optional fingertip configurations. iCub uses distributed skin as part of a research platform. Those disclosures are more useful than a generic statement that a hand can feel.",
          "Tactile sensing also needs software. Raw pressure maps do not automatically produce stable grasps. A policy must detect contact, estimate slip, regulate force and adapt as an object deforms. Few manufacturers publish task-level ablations showing how much tactile input improves success over vision alone."
        ]
      },
      {
        "heading": "Actuation changes strength, speed and safety",
        "paragraphs": [
          "Tendon-driven hands place motors away from the fingers and can reduce distal mass. Tendons also introduce stretch, friction, routing complexity and maintenance. Direct-drive or geared finger modules simplify some control paths but add mass inside the hand. Hydraulic designs can deliver high force and speed, with added pumps, valves and sealing requirements.",
          "Compliance can be mechanical, software-controlled or both. A soft fingertip increases contact area. A backdrivable actuator yields when pushed. Force control limits contact load. These properties matter in a home or shared workspace more than a maximum grip-force figure measured in a power grasp.",
          "Durability is rarely tested under the same conditions. Sharpa publishes cycle and shock tests. Shadow publishes payload and typical movement frequency. 1X publishes nominal and peak load-cycle claims. Those numbers cannot be ranked without knowing duty cycle, maintenance, failure definition and whether the test covered the complete hand or one module."
        ]
      },
      {
        "heading": "Evidence-based categories instead of a false overall ranking",
        "subsections": [
          {
            "heading": "Anthropomorphic architectures",
            "paragraphs": [
              "Sharpa Wave, Shadow Dexterous Hand, 1X NEO and DLR-HIT Hand II publish high-DOF anthropomorphic architectures. “Human-like” refers to kinematics and scale, not equal human dexterity."
            ]
          },
          {
            "heading": "Published tactile-sensing detail",
            "paragraphs": [
              "Sharpa Wave, Figure 03, Shadow and iCub provide the clearest public detail about tactile or distributed sensing. Their sensor modalities and resolutions differ, so this is a documentation category rather than a performance winner."
            ]
          },
          {
            "heading": "Research purchase and integration paths",
            "paragraphs": [
              "Shadow sells a standalone research system, Sharpa accepts orders and Unitree offers Dex3-1 with supported humanoid configurations. iCub is an established institutional platform. Price and delivery require current quotations except where a store lists them."
            ]
          },
          {
            "heading": "Lower-actuation designs",
            "paragraphs": [
              "Unitree Dex3-1 and lower-DOF hands such as IIT R1 reduce actuation complexity. Their suitability depends on the object set and cannot be inferred from DOF alone."
            ]
          },
          {
            "heading": "Published dexterity evidence",
            "paragraphs": [
              "Shadow has extensive technical specifications and research history. Sharpa publishes current hardware, tactile and durability figures. Figure publishes demanding integrated tasks but not a complete hand data sheet. No shared benchmark supports one absolute winner."
            ]
          },
          {
            "heading": "Information insufficient for ranking",
            "paragraphs": [
              "Apptronik Apollo, UBTECH Walker S2, AgiBot’s current hands and Unitree Dex5-1 lack enough consistent public hand-only data for a defensible cross-platform rank."
            ]
          }
        ]
      }
    ],
    "limitations": [
      "Manufacturers count joints, motors, active DOF and wrist axes differently.",
      "Several hands have changed between robot generations; Sanctuary, 1X and UBTECH specifications must be tied to a date and generation.",
      "Grip force, fingertip force and arm payload are different measurements and were not merged.",
      "Company demos use different objects, speeds, training data and success criteria.",
      "Some research hands are commercially orderable components; others exist only as parts of an institutional robot platform."
    ],
    "conclusion": [
      "The best hand depends on the task and on how much evidence the buyer needs. Shadow and Sharpa provide unusually detailed standalone specifications and direct research integration paths. Figure 03 and 1X NEO show how a hand can be designed with the whole robot cameras, soft contact, tendon routing, safety and learned control are part of the manipulation system. Unitree Dex3-1 demonstrates why three fingers can be a rational engineering choice when weight, cost and control simplicity matter.",
      "The largest gap is not finger count. It is comparable testing. Buyers need repeated trials on the same object sets, force limits, slip tests, in-hand rotation, cable insertion, deformable materials, impact cycles and recovery from failed grasps. Until those protocols exist, the most honest comparison separates architecture, sensing, documentation and availability instead of declaring a universal dexterity champion."
    ],
    "faqs": [
      {
        "question": "Which humanoid robot has the most dexterous hand?",
        "answer": "There is no verified universal winner. Sharpa Wave and Shadow publish high-DOF architectures and detailed sensing information. Figure and 1X show integrated whole-robot manipulation. Dexterity also depends on control policies, calibration, wrist motion, tactile feedback and the task, so finger count alone cannot answer the question."
      },
      {
        "question": "How many degrees of freedom does a robotic hand need?",
        "answer": "A narrow task may need only one or two closing axes. A three-finger hand with seven active DOF can perform many useful grasps. High-DOF five-finger hands are valuable for human tools and in-hand manipulation, but they demand more data, control bandwidth and maintenance."
      },
      {
        "question": "Do humanoid robot hands have touch sensors?",
        "answer": "Some do. Figure, Sharpa, Shadow, iCub, Sanctuary and optional Unitree configurations publish tactile, pressure or force sensing. The word tactile covers very different hardware, from sparse contact measurements to dense fingertip arrays, so the sensor type and location should always be stated."
      },
      {
        "question": "Can I buy a humanoid robot hand separately?",
        "answer": "Shadow Dexterous Hand and Sharpa Wave have commercial inquiry or order channels. Unitree offers hands as options for its platforms. Other hands, including Figure 03 and 1X NEO, are integrated products and are not advertised as standalone components. Institutional platforms such as iCub require a quotation."
      },
      {
        "question": "Is a five-finger hand always better than a three-finger hand?",
        "answer": "No. Five fingers provide more human-like contact patterns, but add mass, cost and control complexity. A three-finger design can be faster to calibrate, easier to protect and sufficient for boxes, tools and many industrial parts. The object set and required failure rate should decide."
      },
      {
        "question": "Why do robot hand DOF figures conflict between sources?",
        "answer": "Sources may count active axes, passive coupled joints, wrist axes or total mechanical joints. Products also change between generations. A comparison should quote the manufacturer’s exact term and date rather than silently converting every number into a single DOF field."
      }
    ],
    "methodology": "A hand qualified when it was developed for a full humanoid, humanoid upper body or documented humanoid integration. Parallel industrial grippers were excluded. The comparison uses official product pages, manufacturer technical documents and laboratory pages. No missing specification was estimated from photographs or third-party databases.",
    "sourceLinks": [
      {
        "label": "NEO hands",
        "url": "https://www.1x.tech/discover/neos-hands",
        "organization": "1X Technologies",
        "date": "July 9, 2026",
        "documentTitle": "NEO hands"
      },
      {
        "label": "Introducing Figure 03",
        "url": "https://www.figure.ai/news/introducing-figure-03",
        "organization": "Figure AI",
        "date": "October 9, 2025",
        "documentTitle": "Introducing Figure 03"
      },
      {
        "label": "Unitree G1 and Dex3-1",
        "url": "https://www.unitree.com/g1/",
        "organization": "Unitree Robotics",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Unitree G1 and Dex3-1"
      },
      {
        "label": "Unitree Dex3-1",
        "url": "https://www.unitree.com/mobile/Dex3-1",
        "organization": "Unitree Robotics",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Unitree Dex3-1"
      },
      {
        "label": "Sharpa Wave",
        "url": "https://www.sharpa.com/pages/wave",
        "organization": "Sharpa",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Sharpa Wave"
      },
      {
        "label": "NVIDIA GR00T reference humanoid",
        "url": "https://nvidianews.nvidia.com/news/nvidia-open-humanoid-robot-reference-design",
        "organization": "NVIDIA",
        "date": "May 31, 2026",
        "documentTitle": "NVIDIA GR00T reference humanoid"
      },
      {
        "label": "Shadow Dexterous Hand series",
        "url": "https://shadowrobot.com/dexterous-hand-series/",
        "organization": "Shadow Robot Company",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Shadow Dexterous Hand series"
      },
      {
        "label": "Shadow Dexterous Hand technical specification",
        "url": "https://shadowrobot.com/wp-content/uploads/2025/09/shadow_dexterous_hand_e_technical_specification.pdf",
        "organization": "Shadow Robot Company",
        "date": "2025",
        "documentTitle": "Shadow Dexterous Hand technical specification"
      },
      {
        "label": "Fourier GR-2",
        "url": "https://www.fftai.com/products-gr2",
        "organization": "Fourier",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Fourier GR-2"
      },
      {
        "label": "Sanctuary Phoenix",
        "url": "https://sanctuary.ai/news/sanctuary-ai-unveils-phoenix-a-humanoid-general-purpose-robot-designed-for-work/",
        "organization": "Sanctuary AI",
        "date": "May 16, 2023",
        "documentTitle": "Sanctuary Phoenix"
      },
      {
        "label": "iCub product catalog",
        "url": "https://icub.iit.it/products/product-catalog",
        "organization": "Italian Institute of Technology",
        "date": "Accessed July 11, 2026",
        "documentTitle": "iCub product catalog"
      },
      {
        "label": "IIT R1 robot",
        "url": "https://icub.iit.it/products/r1-robot",
        "organization": "Italian Institute of Technology",
        "date": "Accessed July 11, 2026",
        "documentTitle": "IIT R1 robot"
      },
      {
        "label": "DLR Hand II",
        "url": "https://www.dlr.de/en/rm/research/robotic-systems/hands/hand-ii",
        "organization": "German Aerospace Center",
        "date": "Accessed July 11, 2026",
        "documentTitle": "DLR Hand II"
      },
      {
        "label": "DLR-HIT Hand II",
        "url": "https://www.dlr.de/en/rm/research/robotic-systems/hands/dlr-hit-hand-ii",
        "organization": "German Aerospace Center",
        "date": "Accessed July 11, 2026",
        "documentTitle": "DLR-HIT Hand II"
      },
      {
        "label": "Toyota T-HR3",
        "url": "https://global.toyota/en/detail/19666346",
        "organization": "Toyota Motor Corporation",
        "date": "November 21, 2017",
        "documentTitle": "Toyota T-HR3"
      },
      {
        "label": "UBTECH Walker S2",
        "url": "https://www.ubtrobot.com/en/humanoid/products/walker-s2",
        "organization": "UBTECH Robotics",
        "date": "Accessed July 11, 2026",
        "documentTitle": "UBTECH Walker S2"
      },
      {
        "label": "Apptronik Apollo",
        "url": "https://apptronik.com/our-work/apollo-1",
        "organization": "Apptronik",
        "date": "Accessed July 11, 2026",
        "documentTitle": "Apptronik Apollo"
      },
      {
        "label": "AgiBot products",
        "url": "https://www.agibot.com/",
        "organization": "AgiBot",
        "date": "Accessed July 11, 2026",
        "documentTitle": "AgiBot products"
      }
    ],
    "internalLinks": [
      {
        "label": "Tesla, Figure, Unitree and 1X NEO compared",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      },
      {
        "label": "The complete Physical AI model map",
        "path": "/robotics-news/physical-ai-model-map"
      },
      {
        "label": "Cheapest humanoid robots with public prices",
        "path": "/robotics-news/cheapest-humanoid-robots"
      },
      {
        "label": "Humanoid factory deployments and tasks",
        "path": "/robotics-news/humanoid-factory-deployments"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "A verified 4×4 grid using one official photograph for each named hand.",
        "alt": "Sixteen labeled humanoid robot hands shown in a four-by-four comparison grid",
        "source": "Official manufacturers and research laboratories listed in the source section",
        "sourceUrl": "https://www.sharpa.com/pages/wave"
      },
      {
        "type": "Secondary image",
        "caption": "Sharpa Wave palm and fingertip tactile close-up.",
        "alt": "Sharpa Wave five-finger robotic hand showing its tactile fingertip surfaces",
        "source": "Sharpa",
        "sourceUrl": "https://www.sharpa.com/pages/wave"
      },
      {
        "type": "Secondary image",
        "caption": "Figure 03 hand with palm camera and compliant fingertip detail.",
        "alt": "Figure 03 robotic hand with embedded palm camera and soft tactile fingertips",
        "source": "Figure AI",
        "sourceUrl": "https://www.figure.ai/news/introducing-figure-03"
      },
      {
        "type": "Secondary image",
        "caption": "Unitree Dex3-1 three-finger architecture.",
        "alt": "Unitree Dex3-1 force-controlled three-finger robotic hand",
        "source": "Unitree Robotics",
        "sourceUrl": "https://www.unitree.com/mobile/Dex3-1"
      },
      {
        "type": "Original graphic",
        "caption": "Hand architecture map tendon, geared, hydraulic and coupled designs.",
        "alt": "Taxonomy of humanoid robot hand actuation and tactile sensing designs",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "Sixteen distinct hand systems are listed; no duplicate branding of the same hand is counted twice.",
        "Parallel grippers are excluded.",
        "Hand-only, wrist-inclusive and generation-dependent specifications are distinguished in the comparison."
      ],
      "unconfirmed": [
        "Current hand-only DOF and tactile specifications remain incomplete for Apptronik, UBTECH, AgiBot and Unitree Dex5-1.",
        "No independent common dexterity benchmark covers all sixteen hands."
      ],
      "fastChanging": [
        "Hand configurations, optional tactile packages and order availability can change with robot revisions."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "american-humanoid-robot-companies",
    "slug": "american-humanoid-robot-companies",
    "path": "/robotics-news/american-humanoid-robot-companies",
    "title": "11 US-Based Humanoid Robot Companies Tracked in 2026",
    "headline": "11 US-Based Humanoid Robot Programs With Public Evidence",
    "seoTitle": "11 US-Based Humanoid Robot Companies Tracked in 2026",
    "description": "A methodology-based list of 11 active US-based complete humanoid platforms, with product status, operating base, ownership and current public evidence. Acquired, paused and incomplete programs are listed separately.",
    "category": "Industry map",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "17 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "American humanoid robot companies",
    "keywords": [
      "US humanoid robot companies",
      "American humanoid robots",
      "humanoid robotics startups USA",
      "Tesla Optimus company",
      "Figure AI robot",
      "Agility Digit",
      "Apptronik Apollo",
      "Boston Dynamics Atlas",
      "home robot startups"
    ],
    "searchQuestions": [
      "How many American humanoid robot companies are active?",
      "Which US companies sell humanoid robots?",
      "Is 1X an American company?",
      "Who owns Boston Dynamics?",
      "Which American humanoid robots are deployed?"
    ],
    "longTailKeywords": [
      "US-based humanoid robot companies 2026",
      "US humanoid robotics startups 2026",
      "American wheeled humanoid companies",
      "active humanoid manufacturers in the United States"
    ],
    "entities": [
      "Tesla",
      "Figure AI",
      "Agility Robotics",
      "Apptronik",
      "Boston Dynamics",
      "1X Technologies",
      "Reflex Robotics",
      "Sunday Robotics",
      "Weave Robotics",
      "Persona AI",
      "Foundation Robotics",
      "Fauna Robotics"
    ],
    "introduction": [
      "The United States has no official registry for humanoid manufacturers, so company counts change with the definition. This census includes a business only when it has a principal operating base in the United States and public evidence of a program developing a complete mobile robot with a human-like upper body. The roster includes explicitly labeled development programs as well as demonstrated hardware; it does not count eleven delivered platforms. A hand supplier, an AI model company or a foreign manufacturer with a US sales office does not qualify. Wheeled robots are included when they have a torso, two arms and a general manipulation role; ownership and country of origin are reported separately.",
      "Using that rule, the tracked field runs from established manufacturers such as Tesla, Boston Dynamics and Agility Robotics to home-robot companies such as Sunday Robotics and Weave Robotics. Commercial status varies by company. Digit has documented customer operations, Figure publishes delivery counts and NEO has a consumer order program. Other programs remain prototypes, pilots or pre-production systems. The table records evidence rechecked through September 26, 2026 and keeps each status tied to its source."
    ],
    "keyFindings": [
      "Eleven active US-based companies have public evidence of a complete humanoid or wheeled humanoid program under the definition used here.",
      "Agility Robotics reports more than 65,000 Digit 4 operational hours across named customer sites, while Figure reported more than 350 Figure 03 deliveries by April 2026.",
      "1X is Norwegian-founded but now operates from Palo Alto; it is listed as US-based with its origin stated, not recast as a US-founded company.",
      "Boston Dynamics is headquartered in Massachusetts and owned by Hyundai Motor Group, so headquarters and ownership point to different countries.",
      "Several widely cited “humanoid companies” build hands, AI models or components only and are excluded from the manufacturer count."
    ],
    "comparisonTables": [
      {
        "id": "american-humanoid-company-census",
        "title": "Active US-based complete humanoid programs",
        "description": "Status reflects primary-source evidence rechecked through September 26, 2026. “Not disclosed” is used instead of inferred funding, autonomy or shipment figures.",
        "columns": [
          "Company",
          "US base and origin",
          "Robot / form",
          "Public objective",
          "Current evidence",
          "Autonomy classification"
        ],
        "rows": [
          [
            "Tesla",
            "Austin, Texas; US-founded",
            "Optimus; biped",
            "General-purpose work, initially inside Tesla",
            "Active development and internal factory demonstrations; no public sale or verified fleet count",
            "Autonomy not disclosed for individual clips"
          ],
          [
            "Figure AI",
            "California; US-founded in 2022",
            "Figure 03; biped",
            "Industrial logistics and later home work",
            "Figure says more than 350 Figure 03 units had been delivered by April 2026; BMW programs are documented separately",
            "Supervised autonomous to autonomous, depending on the named demo"
          ],
          [
            "Agility Robotics",
            "Oregon; 2015 Oregon State University spin-off",
            "Digit; biped with two arms",
            "Repetitive material movement in logistics and manufacturing",
            "Commercial agreements and recurring tote-moving work are publicly documented",
            "Supervised autonomous with fleet monitoring"
          ],
          [
            "Apptronik",
            "Austin, Texas; 2016 University of Texas spin-off",
            "Apollo; biped and industrial configurations",
            "Material movement, kitting, inspection and machine tending",
            "Pilots and commercial agreements with Mercedes-Benz and Jabil; public unit counts not disclosed",
            "Human-in-the-loop or supervised autonomous; task-specific evidence varies"
          ],
          [
            "Boston Dynamics",
            "Waltham, Massachusetts; US-founded, Hyundai-owned",
            "Atlas; electric biped",
            "Industrial material handling",
            "Production-ready model announced in January 2026; Hyundai is the first customer with 2026 fleet shipment scheduled",
            "Supervised autonomous; deployment results not yet public"
          ],
          [
            "1X Technologies",
            "Palo Alto, California; Norwegian-founded",
            "NEO; soft biped",
            "Home assistance",
            "$200 deposit, $20,000 Early Access ownership price and US deliveries planned for 2026",
            "Human-in-the-loop plus foundational autonomy"
          ],
          [
            "Reflex Robotics",
            "United States; detailed corporate history not publicly disclosed",
            "Reflex; wheeled humanoid",
            "Manufacturing and logistics jobs",
            "Company shows supervised work and explicitly describes real-time supervision; price appears only in recruiting material",
            "Human-in-the-loop / supervised autonomous"
          ],
          [
            "Sunday Robotics",
            "California; US-based",
            "Memo; wheeled home robot",
            "Dishes, coffee and laundry in homes",
            "Free late-2026 beta applications; no retail sale before beta completion",
            "Company-classified autonomous demonstrations; independent validation absent"
          ],
          [
            "Weave Robotics",
            "California; US-based",
            "Isaac 0 and Isaac 1; stationary or mobile home platforms",
            "Laundry and household assistance",
            "Isaac 0 has a limited California order program; Isaac 1 deposits target fall 2026",
            "Supervised autonomous; remote assistance terms should be checked per service plan"
          ],
          [
            "Persona AI",
            "Houston, Texas; US-based",
            "Industrial humanoid concept",
            "Shipbuilding, manufacturing and hazardous work",
            "Prototype and partner development; production model and delivery evidence not yet public",
            "Insufficient evidence"
          ],
          [
            "Foundation",
            "San Francisco Bay Area; US-based",
            "Phantom; biped industrial robot",
            "General industrial labor",
            "Public robot program and hiring; customer, shipment and autonomy data remain limited",
            "Autonomy not disclosed"
          ]
        ]
      },
      {
        "id": "non-active-and-excluded",
        "title": "Programs that need a separate label",
        "description": "These names should not be added to the active-company total without qualification.",
        "columns": [
          "Category",
          "Company or example",
          "Reason for separate treatment"
        ],
        "rows": [
          [
            "Acquired",
            "Fauna Robotics",
            "Fauna announced that it joined Amazon in March 2026. Sprout remains a documented robot, but the company is no longer counted as an independent active manufacturer."
          ],
          [
            "Paused or closed",
            "K-Scale Labs",
            "The open-source K-Bot/K-Scale material remains online, but current commercial operations and shipping are not confirmed by an active official sales channel."
          ],
          [
            "Stealth with incomplete evidence",
            "The Bot Company",
            "The company describes a helpful robot but does not publish enough body-form evidence to classify it as a humanoid manufacturer."
          ],
          [
            "Components only",
            "PSYONIC, Shadow Robot, Sharpa",
            "These companies build hands or manipulation hardware, not a complete mobile humanoid platform."
          ],
          [
            "AI only",
            "Skild AI, Physical Intelligence",
            "They build general robotics models or policies and may work across humanoid hardware, but do not market a complete humanoid robot."
          ],
          [
            "Foreign company with US presence",
            "Unitree, UBTECH, Fourier Intelligence",
            "A US distributor, office or customer does not change the manufacturer’s national origin."
          ]
        ]
      }
    ],
    "sections": [
      {
        "heading": "How an “American humanoid company” is defined",
        "paragraphs": [
          "The company must have its main operating headquarters or principal robot-development organization in the United States. A US-incorporated subsidiary of a foreign manufacturer is not enough. Conversely, a company can qualify as US-based while retaining a foreign founding history, as 1X does after moving its headquarters to Palo Alto. Ownership is another field Boston Dynamics remains a Massachusetts robotics company even though Hyundai Motor Group is its controlling owner.",
          "The robot must be a complete mobile platform intended to manipulate the physical world. The census accepts bipeds and wheeled humanoids because both use human-scale arms and workstations. Fixed arms, disembodied hands, telepresence screens and social heads are excluded. A public render alone is insufficient; the company must show hardware, a named prototype or a credible development program."
        ]
      },
      {
        "heading": "The industrial group is ahead on deployment evidence",
        "paragraphs": [
          "Agility has the clearest distinction between a robot, a factory and a customer workflow. Its official company history says Digit moved more than 100,000 totes at one Georgia facility, while commercial announcements identify customers such as GXO, Schaeffler and Toyota Motor Manufacturing Canada. Figure reports more than 350 Figure 03 deliveries and publishes detailed BMW results, although those results must be separated by generation and program.",
          "Apptronik’s Mercedes-Benz agreement is explicitly a pilot. Boston Dynamics calls the 2026 Atlas production-ready and says Hyundai is the first customer, but scheduled shipment is not the same as completed deployment. Tesla shows Optimus inside its own organization but does not publish audited shift hours, customer deliveries or a public product configuration. These differences make a single “deployed” label misleading."
        ]
      },
      {
        "heading": "Home robots use different commercial models",
        "paragraphs": [
          "NEO is offered through a refundable deposit, an Early Access ownership price and a monthly plan. The offer also describes Expert Mode, which means a person can remotely help with chores the robot cannot complete. Weave sells or subscribes Isaac 0 in a limited California service area and takes a deposit for Isaac 1. Sunday’s Memo is not for sale; selected households can apply to a free beta launching late in 2026.",
          "A deposit proves customer acquisition, not general autonomy or mass delivery. A beta proves field testing, not product reliability. Each commercial label in this census therefore tracks the exact transaction public purchase, subscription, refundable reservation, enterprise quote or application-only program."
        ]
      },
      {
        "heading": "Founders, funding and stealth claims require restraint",
        "paragraphs": [
          "Founders and funding are included only when an official company page, filing or announcement supports them. Private-company databases frequently disagree about headquarters, founding dates and round totals. Those disagreements are more likely after acquisitions, headquarters moves or extended financing rounds.",
          "Stealth companies present a second problem. A recruiting page can show that engineers are building a robot, but it may not establish the machine’s form, customer or current status. The Bot Company is therefore listed as incomplete evidence rather than counted as a confirmed humanoid manufacturer."
        ]
      }
    ],
    "limitations": [
      "There is no government or industry registry of US humanoid manufacturers, so the count depends on a published definition.",
      "Private companies can change headquarters, ownership and project status without a synchronized public filing.",
      "Company-reported deliveries and work hours are not necessarily independently audited.",
      "Stealth programs and recently closed companies may be undercounted because current primary evidence is unavailable.",
      "A wheeled humanoid is included only when it has a complete human-scale manipulation body; readers using a biped-only definition will obtain a smaller count."
    ],
    "conclusion": [
      "US-based humanoid programs target different buyers and tasks. Agility, Figure, Apptronik, Boston Dynamics and Tesla focus on industrial workflows, with public evidence ranging from recurring customer work to scheduled fleets and internal tests. 1X, Sunday and Weave focus on home use, where service coverage, remote assistance and household reliability are central operating constraints. Reflex uses a wheeled base and explicit supervision for factory work, while Persona and Foundation remain earlier-stage programs with limited public operating data.",
      "For readers comparing companies, useful checks include whether a robot shipped, whether it repeated a customer task across shifts, whether a human intervened and whether a buyer can purchase the system or only join a waitlist. Applying the published definition leaves eleven active US-based complete-platform programs in this September 2026 review, with acquired, paused and incomplete programs listed separately."
    ],
    "faqs": [
      {
        "question": "How many American humanoid robot companies are active in 2026?",
        "answer": "This census identifies eleven active US-based companies with public evidence of a complete biped or wheeled humanoid program. The total changes under a biped-only definition and may change as stealth companies publish hardware, projects close or foreign-founded companies move headquarters. It is a methodology-based count, not an official government statistic."
      },
      {
        "question": "Is 1X an American humanoid robot company?",
        "answer": "1X is Norwegian-founded and developed early robots in Norway, but the company now describes Palo Alto as its headquarters. This article lists it as US-based while preserving the founding origin. That is more precise than calling it simply American or Norwegian because headquarters, founding history and current engineering footprint are different facts."
      },
      {
        "question": "Which American humanoid company has the strongest deployment evidence?",
        "answer": "Agility Robotics publishes the clearest evidence of repeated customer work, including tote movement and named commercial relationships. Figure also publishes substantial BMW operating data and a recent unit-delivery count. The comparison remains imperfect because companies report different metrics, generations, task definitions and intervention policies, and the numbers are not audited under one standard."
      },
      {
        "question": "Can consumers buy an American humanoid robot now?",
        "answer": "1X accepts a refundable NEO deposit and publishes ownership and subscription prices. Weave offers Isaac 0 in a limited California program and reservations for Isaac 1. Sunday Memo is beta-only. These offers are not equivalent one may be a preorder, another a regional service and another an application for testing rather than a normal retail shipment."
      },
      {
        "question": "Why are hand and AI companies excluded?",
        "answer": "The article counts companies developing complete mobile humanoid platforms, including the development-stage programs explicitly labeled in the table. A company supplying tactile hands, actuators, foundation models or simulation software can be crucial to the industry without manufacturing a humanoid body. Combining component makers with full-platform companies would inflate the count and make national comparisons impossible because the same supplier can serve several competing robots."
      },
      {
        "question": "Does Hyundai ownership make Boston Dynamics a Korean company?",
        "answer": "Boston Dynamics is headquartered in Massachusetts and originated in the United States, while Hyundai Motor Group is its controlling owner. Both facts belong in the company record. This census classifies operating base and origin separately from ownership, avoiding the false choice of assigning a multinational company to only one national category."
      }
    ],
    "methodology": [
      "Companies were checked against official product, company, order, acquisition and partnership pages. A complete-platform rule was applied consistently to bipeds and wheeled humanoids. Status words such as pilot, deployment, beta, reservation and shipment retain the manufacturer’s documented meaning.",
      "The census was rechecked on September 26, 2026. Missing founder, funding, unit and autonomy data remain undisclosed rather than being reconstructed from investor databases or social posts."
    ],
    "sourceLinks": [
      {
        "label": "Tesla AI and Robotics",
        "url": "https://www.tesla.com/AI",
        "organization": "Tesla",
        "date": "accessed July 11, 2026",
        "documentTitle": "Tesla AI and Robotics"
      },
      {
        "label": "Figure company and Figure 03",
        "url": "https://www.figure.ai/",
        "organization": "Figure AI",
        "date": "accessed July 11, 2026",
        "documentTitle": "Figure company and Figure 03"
      },
      {
        "label": "Ramping Figure 03 Production",
        "url": "https://www.figure.ai/news/ramping-figure-03-production",
        "organization": "Figure AI",
        "date": "April 29, 2026",
        "documentTitle": "Ramping Figure 03 Production"
      },
      {
        "label": "Agility company history and RoboFab",
        "url": "https://www.agilityrobotics.com/company",
        "organization": "Agility Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Agility company history and RoboFab"
      },
      {
        "label": "Apollo product page",
        "url": "https://apptronik.com/our-work/apollo-1",
        "organization": "Apptronik",
        "date": "accessed July 11, 2026",
        "documentTitle": "Apollo product page"
      },
      {
        "label": "Apptronik and Mercedes-Benz commercial agreement",
        "url": "https://apptronik.com/company/press-releases-collection/apptronik-and-mercedes-benz-enter-commercial-agreement",
        "organization": "Apptronik",
        "date": "March 15, 2024",
        "documentTitle": "Apptronik and Mercedes-Benz commercial agreement"
      },
      {
        "label": "Atlas humanoid robot",
        "url": "https://bostondynamics.com/products/atlas/",
        "organization": "Boston Dynamics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Atlas humanoid robot"
      },
      {
        "label": "Enterprise Robotics, Redefined",
        "url": "https://bostondynamics.com/blog/enterprise-robotics-redefined/",
        "organization": "Boston Dynamics",
        "date": "2026",
        "documentTitle": "Enterprise Robotics, Redefined"
      },
      {
        "label": "NEO product and order program",
        "url": "https://www.1x.tech/neo",
        "organization": "1X Technologies",
        "date": "accessed July 11, 2026",
        "documentTitle": "NEO product and order program"
      },
      {
        "label": "Reflex Robotics official site",
        "url": "https://reflexrobotics.com/",
        "organization": "Reflex Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Reflex Robotics official site"
      },
      {
        "label": "Sunday Memo official site",
        "url": "https://www.sunday.ai/",
        "organization": "Sunday Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Sunday Memo official site"
      },
      {
        "label": "Weave Robotics official site",
        "url": "https://www.weaverobotics.com/",
        "organization": "Weave Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Weave Robotics official site"
      },
      {
        "label": "Persona AI official site",
        "url": "https://persona.ai/",
        "organization": "Persona AI",
        "date": "accessed July 11, 2026",
        "documentTitle": "Persona AI official site"
      },
      {
        "label": "Foundation official site",
        "url": "https://foundation.bot/",
        "organization": "Foundation",
        "date": "accessed July 11, 2026",
        "documentTitle": "Foundation official site"
      },
      {
        "label": "Fauna Robotics joins Amazon",
        "url": "https://faunarobotics.com/news/fauna-robotics-joins-amazon",
        "organization": "Fauna Robotics",
        "date": "March 24, 2026",
        "documentTitle": "Fauna Robotics joins Amazon"
      }
    ],
    "internalLinks": [
      {
        "label": "Compare Tesla Optimus, Figure 03, Unitree G1 and 1X NEO",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      },
      {
        "label": "See which humanoid factory projects are real deployments or pilots",
        "path": "/robotics-news/humanoid-factory-deployments"
      },
      {
        "label": "Compare China and US humanoid production evidence",
        "path": "/robotics-news/china-vs-usa-humanoid-robot-production"
      },
      {
        "label": "Check the cheapest humanoid robots with public prices",
        "path": "/robotics-news/cheapest-humanoid-robots"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "A verified lineup of active US humanoid robots, labeled by company and platform form.",
        "alt": "American humanoid robots from Tesla, Figure, Agility, Apptronik, Boston Dynamics and 1X shown with company labels",
        "source": "Official manufacturer media pages",
        "sourceUrl": "https://www.figure.ai/"
      },
      {
        "type": "Secondary image",
        "caption": "Digit working with totes in an operational logistics setting.",
        "alt": "Agility Robotics Digit moving a tote in a customer logistics facility",
        "source": "Agility Robotics",
        "sourceUrl": "https://www.agilityrobotics.com/company"
      },
      {
        "type": "Secondary image",
        "caption": "Production-ready Atlas in the 2026 industrial configuration.",
        "alt": "Boston Dynamics electric Atlas industrial humanoid robot",
        "source": "Boston Dynamics",
        "sourceUrl": "https://bostondynamics.com/products/atlas/"
      },
      {
        "type": "Secondary image",
        "caption": "NEO in a furnished home environment, using the current production design.",
        "alt": "1X NEO soft-bodied humanoid robot inside a home",
        "source": "1X Technologies",
        "sourceUrl": "https://www.1x.tech/neo"
      },
      {
        "type": "Original graphic",
        "caption": "US company map separated into active, acquired, paused and unconfirmed groups.",
        "alt": "Map of United States humanoid robot companies by headquarters and status",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "Eleven active companies meet the stated complete-platform and US-base criteria.",
        "Fauna Robotics publicly announced its acquisition by Amazon.",
        "Company origin, headquarters and ownership are recorded separately."
      ],
      "unconfirmed": [
        "Current operating status of K-Scale Labs is not confirmed through an active official sales channel.",
        "The Bot Company has not published enough body-form evidence to count as a humanoid manufacturer.",
        "Private funding totals and customer fleet counts are omitted where primary documents are unavailable."
      ],
      "fastChanging": [
        "Headquarters, acquisitions, stealth-company disclosures and 2026 beta programs can change quickly."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "china-vs-usa-humanoid-robot-production",
    "slug": "china-vs-usa-humanoid-robot-production",
    "path": "/robotics-news/china-vs-usa-humanoid-robot-production",
    "title": "China vs USA Humanoid Robot Production in 2026",
    "headline": "China and the United States What the Humanoid Production Numbers Actually Show",
    "seoTitle": "China vs USA Humanoid Robot Production Compared in 2026",
    "description": "A documented comparison of Chinese and US humanoid production, shipments, factory capacity, supply chains, orders, pilots and government support.",
    "category": "Industry analysis",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "18 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "China vs USA humanoid robot production",
    "keywords": [
      "China humanoid robot production",
      "USA humanoid robot production",
      "humanoid robot shipments 2025",
      "Unitree sales",
      "AgiBot production",
      "Figure robot deliveries",
      "humanoid supply chain",
      "robot actuator manufacturing",
      "humanoid government policy"
    ],
    "searchQuestions": [
      "Which country produces more humanoid robots?",
      "How many humanoid robots did China ship?",
      "How many Figure robots were delivered?",
      "Does the US or China lead humanoid manufacturing?",
      "What counts as humanoid production?"
    ],
    "longTailKeywords": [
      "China versus United States humanoid robot manufacturing",
      "verified humanoid robot shipment numbers 2026",
      "Chinese humanoid production capacity vs US",
      "humanoid robot orders pilots and deliveries explained"
    ],
    "entities": [
      "Unitree Robotics",
      "AgiBot",
      "UBTECH",
      "Figure AI",
      "Agility Robotics",
      "Tesla",
      "1X Technologies",
      "International Federation of Robotics",
      "China Ministry of Industry and Information Technology"
    ],
    "introduction": [
      "China and the United States report humanoid progress in incompatible units. A report released at the 2026 World Robot Conference says China shipped more than 40,000 humanoid robots in the first half of 2026 and accounted for 97 percent of global shipments under that report’s market definition. Unitree separately says it shipped more than 5,500 humanoids in 2025 and produced more than 6,500. AgiBot’s production counter reached 20,000 robots on September 24, 2026 across its portfolio. Figure says it had delivered more than 350 Figure 03 robots by April 2026. Agility’s Oregon RoboFab advertises peak capacity of 10,000 Digit robots per year, but capacity is not output.",
      "This article keeps those categories separate. A factory nameplate is production capacity. A machine leaving a line is manufactured. A delivered machine has reached a recipient. A purchase order can be paid, conditional or non-binding. A pilot agreement can involve one robot and no sale. Government targets are policy, not shipments. The global totals themselves show why company counts cannot be added mechanically: the International Federation of Robotics reported about 7,000 humanoids sold worldwide in 2025 for its industrial and professional-service scope, while Omdia, as cited by AgiBot, estimated about 13,000 humanoid shipments under a broader market classification. Neither country provides a complete audited national total."
    ],
    "keyFindings": [
      "A 2026 World Robot Conference report puts China above 40,000 humanoid shipments in the first half of 2026 and at 97 percent of global shipments under its stated market definition; this is a report figure, not an audited national registry.",
      "US manufacturers publish substantial planned capacity, but Figure’s 350-plus delivered Figure 03 units are the clearest recent US delivery number found.",
      "Unitree explicitly separates 2025 output from shipments, preventing a common mistake in industry comparisons.",
      "AgiBot said its 20,000th robot rolled off the production line on September 24, 2026. The milestone covers its robot portfolio and should not be read as 20,000 full-size humanoids delivered to paying customers.",
      "China has a dense domestic component and manufacturing ecosystem, while US companies in this source set have prominent frontier-AI partnerships, capital-intensive factories and named industrial programs. These are different evidence categories and are not combined into one score."
    ],
    "comparisonTables": [
      {
        "id": "national-production-scorecard",
        "title": "Documented production evidence by country",
        "description": "Numbers retain the scope and wording of the source. They are not combined into an audited national total.",
        "columns": [
          "Metric",
          "China",
          "United States",
          "What can be concluded"
        ],
        "rows": [
          [
            "Units shipped",
            "World Robot Conference report: more than 40,000 humanoid robots shipped in China in H1 2026, representing 97% of global shipments under that report’s definition. Unitree and AgiBot company figures use separate scopes and are not added to this total.",
            "No complete national total. Figure more than 350 Figure 03 units delivered by April 2026.",
            "The conference report supports a large Chinese shipment lead under its stated market definition; it is not an audited national registry and should not be merged with company counters."
          ],
          [
            "Units manufactured",
            "Unitree more than 6,500 humanoids produced in 2025. AgiBot 20,000th robot off its line on September 24, 2026 across its product portfolio.",
            "Figure demonstrates one Figure 03 per hour and reports deliveries; Tesla output remains undisclosed.",
            "Manufactured is not the same as shipped or deployed."
          ],
          [
            "Production capacity",
            "Multiple Chinese factories announce lines and annual targets; comparable audited utilization is unavailable.",
            "Agility RoboFab states peak annual capacity of 10,000 Digit robots. Figure BotQ initially targeted 12,000 units per year.",
            "Nameplate capacity shows equipment and process ambition, not actual annual output."
          ],
          [
            "Paid orders",
            "Some Chinese companies announce order values or large unit totals, but payment and binding terms are often unclear.",
            "Agility has cited commercial orders with conditions; detailed customer payment schedules are private.",
            "Order headlines cannot be added to shipment totals."
          ],
          [
            "Pilots",
            "Broad automotive trials involving UBTECH, AgiBot and other suppliers are public, frequently without robot counts or shift data.",
            "BMW, GXO, Schaeffler, Mercedes-Benz, Jabil, Toyota and Hyundai programs are named in official announcements.",
            "The US sample offers stronger customer-specific documentation, not necessarily greater volume."
          ],
          [
            "Government support",
            "National and local policy explicitly promotes humanoids, innovation centers, standards and industrial clusters.",
            "Federal support is distributed across research, defense, manufacturing and AI programs; no single comparable national humanoid plan was found.",
            "Policy architecture differs and cannot be converted directly into units."
          ]
        ]
      },
      {
        "id": "major-manufacturers-two-countries",
        "title": "Major manufacturers and the latest quantified evidence",
        "description": "A blank figure means the company did not publish a comparable current number in the primary sources reviewed.",
        "columns": [
          "Country",
          "Manufacturer",
          "Published product or factory evidence",
          "Classification"
        ],
        "rows": [
          [
            "China",
            "Unitree",
            "More than 5,500 humanoid shipments and more than 6,500 units produced in 2025, according to its clarification.",
            "Units shipped and manufactured; company-reported"
          ],
          [
            "China",
            "AgiBot",
            "20,000th robot production-line milestone on September 24, 2026; this is a portfolio production count, not a customer-delivery total.",
            "Portfolio production milestone and analyst shipment estimate"
          ],
          [
            "China",
            "UBTECH",
            "Walker industrial programs and annual-report disclosures; exact comparable shipped-humanoid total not used here.",
            "Pilots, orders and company reporting; scope varies"
          ],
          [
            "China",
            "Fourier Intelligence",
            "GR-series commercial and research programs; current audited annual output not disclosed.",
            "Product availability and deployments, no comparable total"
          ],
          [
            "United States",
            "Figure AI",
            "More than 350 Figure 03 units delivered by April 2026; one-unit-per-hour line demonstrated.",
            "Delivered units and demonstrated line rate; company-reported"
          ],
          [
            "United States",
            "Agility Robotics",
            "RoboFab peak capacity of 10,000 per year; customer work documented.",
            "Capacity and deployment, not 10,000 units produced"
          ],
          [
            "United States",
            "Tesla",
            "Large production goals discussed by executives, but current completed units and external shipments are not publicly disclosed.",
            "Planned capacity or internal production claim"
          ],
          [
            "United States",
            "1X Technologies",
            "NEO Factory announced for consumer production; completed 2026 deliveries not yet quantified.",
            "Planned production and preorder program"
          ],
          [
            "United States",
            "Boston Dynamics",
            "Production-ready Atlas and a Hyundai fleet scheduled for 2026.",
            "Announced customer shipment; completed count not public"
          ],
          [
            "United States",
            "Apptronik",
            "Manufacturing partnerships and customer pilots; Apollo unit output not public.",
            "Pilot and scaling agreement"
          ]
        ]
      }
    ],
    "sections": [
      {
        "heading": "Production, shipment and deployment are different ledgers",
        "paragraphs": [
          "Unitree’s clarification publishes two separate numbers: output above 6,500 and shipments above 5,500 for 2025. The gap can include inventory, internal units, timing and channel stock. AgiBot’s 20,000th robot milestone is a production-line counter across a portfolio. It does not prove that 20,000 full-size humanoids were paid for, delivered or operating in factories.",
          "Figure’s 350-plus figure is described as delivered Figure 03 units. Agility’s 10,000 figure is peak annual factory capacity. These values answer different questions and cannot be placed in one bar chart labeled “robots produced” without distortion. A reliable comparison therefore keeps a ledger for capacity, manufactured units, shipments, deliveries, orders and active deployments."
        ]
      },
      {
        "heading": "China’s advantage begins below the final assembly line",
        "paragraphs": [
          "China’s robotics ecosystem sits near large domestic industries for batteries, electric motors, power electronics, precision machining, cameras and contract manufacturing. Humanoid suppliers can source or iterate many subsystems inside regional clusters. Government policy also names humanoids as a strategic emerging sector and supports innovation centers, standards and pilot applications.",
          "That proximity does not mean every critical component is domestic or equivalent. High-end reducers, force-torque sensors, encoders, tactile skins, GPUs and precision bearings can still depend on specialist suppliers or imports. The useful claim is supply-chain density and manufacturing speed, not complete technological self-sufficiency."
        ]
      },
      {
        "heading": "The US advantage is concentrated in AI and customer integration",
        "paragraphs": [
          "US companies have access to frontier multimodal models, large cloud and chip ecosystems, deep venture financing and industrial customers willing to run pilots. Figure’s Helix, Apptronik’s partnership with Google DeepMind and NVIDIA’s humanoid platform work illustrate this concentration. Customer announcements often describe the exact task, site and partner even when unit counts remain private.",
          "The manufacturing base is less uniform. Agility operates a dedicated factory in Oregon, Figure runs BotQ and 1X announced a NEO factory, while other companies depend on contract manufacturers or development lines. Large goals from executives should be recorded as targets until production and delivery data appear."
        ]
      },
      {
        "heading": "Orders and memorandums are the noisiest numbers",
        "paragraphs": [
          "A supplier may announce a framework order, intended purchase, memorandum or potential fleet value before acceptance testing, financing and delivery schedules are complete. Chinese and US announcements both use this language. An order count is strongest when the source identifies a binding customer, paid amount, delivery window and product configuration. Most public releases omit at least one of those fields.",
          "This article therefore does not convert quoted order value into robot units and does not treat a memorandum as a sale. It also avoids adding pilots across companies because one “pilot” can mean a single supervised robot for weeks while another means several robots in recurring operations."
        ]
      },
      {
        "heading": "What would make the comparison auditable",
        "paragraphs": [
          "The industry needs common quarterly fields completed units by model, external shipments, accepted deliveries, customer-active units, paid orders, cancellations, average operating hours and human-intervention rate. Production capacity should include utilization and yield. Deployment reports should identify the task, site, fleet size and observation period.",
          "Until companies publish those fields, national league tables will remain estimates assembled from incompatible announcements. The present evidence supports a Chinese volume lead, but not a precise national ratio or a claim that every shipped unit is doing economically useful work."
        ]
      }
    ],
    "limitations": [
      "No audited national registry reports humanoid output for either country.",
      "Unitree, AgiBot and Figure figures are company-reported or based on cited industry analysis, not a common financial standard.",
      "Product portfolios differ small educational bipeds, full-size humanoids and wheeled systems may be counted differently.",
      "Chinese order releases often omit binding terms; US pilot releases often omit unit counts and operating hours.",
      "Component-country attribution is difficult because finished robots contain globally sourced chips, sensors, reducers and software."
    ],
    "conclusion": [
      "The public company disclosures reviewed here are larger for several Chinese suppliers than for individual US suppliers, but they do not produce an audited national total. Unitree’s shipment and output figures and AgiBot’s production milestones use company-specific scopes, while IFR and Omdia publish different global totals because their market definitions differ. China also has dense component and contract-manufacturing clusters plus explicit industrial policy, but the exact country-to-country volume gap cannot be calculated from these disclosures.",
      "The US sample has more public detail around several named customer workflows, frontier model partnerships and dedicated factories with planned capacity. Figure’s delivery count and BMW documentation are current examples; Agility’s RoboFab is capacity, not proof of 10,000 annual units. The source set shows higher disclosed company-level volume figures from several Chinese suppliers and more customer-specific US operating detail, while neither side provides an audited national production ledger."
    ],
    "faqs": [
      {
        "question": "Does China produce more humanoid robots than the United States?",
        "answer": "A report released at the 2026 World Robot Conference says China shipped more than 40,000 humanoid robots in the first half of 2026 and accounted for 97 percent of global shipments under that report’s definition. That supports a large volume lead in this source set, but it is not an audited national registry and its market definition should not be mixed with company-specific production or delivery counts."
      },
      {
        "question": "Did AgiBot deliver 20,000 humanoid robots?",
        "answer": "AgiBot announced that its 20,000th robot came off the production line on September 24, 2026. That is a manufacturing milestone across its product portfolio, not proof that 20,000 full-size humanoids were delivered to paying customers. Production-line counts and shipment counts should stay separate."
      },
      {
        "question": "Is factory capacity the same as robot production?",
        "answer": "No. Agility’s RoboFab peak capacity of 10,000 robots per year and Figure’s initial BotQ target describe what a facility is designed to support. Actual production depends on orders, suppliers, labor, yield and line utilization. A credible production comparison uses completed units, while capacity belongs in a separate column."
      },
      {
        "question": "Why are announced orders not counted as shipments?",
        "answer": "An announcement may describe a memorandum, framework agreement, conditional purchase or intended fleet. Payment, acceptance testing and delivery can occur later or never. Shipments require a robot to leave the supplier for a recipient, and deployment requires evidence that it is operating. Those stages have different commercial and technical meaning."
      },
      {
        "question": "Which country has the stronger humanoid supply chain?",
        "answer": "The Chinese examples in this article emphasize component sourcing and assembly scale; the US examples emphasize AI, software and system integration. This selection does not measure national superiority across those fields. Both groups also use international suppliers for selected sensors, semiconductors, reducers, bearings and production equipment."
      },
      {
        "question": "Are government targets included in production totals?",
        "answer": "No. Chinese policy documents and local plans can direct funding, standards and pilot programs, but a target is not a manufactured unit. US research or industrial grants are also not output. Policy is analyzed as an enabling condition and kept separate from factories, shipped robots, paid orders and active deployments."
      }
    ],
    "methodology": [
      "Primary manufacturer pages were used for company counts, production milestones, line rates, factory capacity and deployment statements. Chinese government publications were used to document policy direction. Every number was assigned to one category capacity, manufactured, shipped, delivered, ordered, piloted or deployed.",
      "Core volume definitions were rechecked on September 26, 2026. No market forecast was converted into actual production, and overlapping company or analyst totals were not added into a national sum. IFR and Omdia totals are kept separate because their humanoid-market scopes differ."
    ],
    "sourceLinks": [
      {
        "label": "Clarification Regarding Unitree’s 2025 Sales Data",
        "url": "https://shop.unitree.com/blogs/news/clarification-regarding-unitrees-2025-sales-data",
        "organization": "Unitree Robotics",
        "date": "2026",
        "documentTitle": "Clarification Regarding Unitree’s 2025 Sales Data"
      },
      {
        "label": "IFR 2025 global humanoid sales scope",
        "url": "https://www.reuters.com/technology/humanoid-robot-sales-tally-hit-7000-globally-last-year-2026-09-21/",
        "organization": "Reuters / International Federation of Robotics",
        "date": "September 21, 2026",
        "documentTitle": "Humanoid robot sales tally hit 7,000 globally last year"
      },
      {
        "label": "AgiBot 20,000th Production Milestone",
        "url": "https://www.agibot.com/article/231/detail/123.html",
        "organization": "AgiBot",
        "date": "September 24, 2026",
        "documentTitle": "AGIBOT and Chimelong Launch Large-Scale Embodied AI Theme Park with More Than 300 Robots"
      },
      {
        "label": "World Robot Conference 2026 shipment report",
        "url": "https://invest.beijing.gov.cn/english/Background/Activities/202608/t20260826_4837501.html",
        "organization": "Beijing Investment Promotion Service Center",
        "date": "August 26, 2026",
        "documentTitle": "2026 World Robot Conference Concludes: Beijing Robot Domain Charts a New Blueprint for Embodied AI"
      },
      {
        "label": "AgiBot News and Production Updates",
        "url": "https://www.agibot.com/about/news",
        "organization": "AgiBot",
        "date": "accessed July 11, 2026",
        "documentTitle": "AgiBot News and Production Updates"
      },
      {
        "label": "UBTECH 2025 Annual Report",
        "url": "https://owebsite-cdn.ubtrobot.com/resources/file/2026/04/21/797179114676293.pdf",
        "organization": "UBTECH Robotics",
        "date": "2026",
        "documentTitle": "UBTECH 2025 Annual Report"
      },
      {
        "label": "China sets sights on humanoid robots",
        "url": "https://english.www.gov.cn/news/202410/11/content_WS67092284c6d0868f4e8ebb88.html",
        "organization": "State Council of the People’s Republic of China",
        "date": "October 11, 2024",
        "documentTitle": "China sets sights on humanoid robots"
      },
      {
        "label": "Ramping Figure 03 Production",
        "url": "https://www.figure.ai/news/ramping-figure-03-production",
        "organization": "Figure AI",
        "date": "April 29, 2026",
        "documentTitle": "Ramping Figure 03 Production"
      },
      {
        "label": "Agility company and RoboFab",
        "url": "https://www.agilityrobotics.com/company",
        "organization": "Agility Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Agility company and RoboFab"
      },
      {
        "label": "NEO Factory",
        "url": "https://www.1x.tech/discover/neo-factory",
        "organization": "1X Technologies",
        "date": "accessed July 11, 2026",
        "documentTitle": "NEO Factory"
      },
      {
        "label": "Atlas production-ready announcement",
        "url": "https://bostondynamics.com/blog/boston-dynamics-unveils-new-atlas-robot-to-revolutionize-industry/",
        "organization": "Boston Dynamics",
        "date": "January 5, 2026",
        "documentTitle": "Atlas production-ready announcement"
      },
      {
        "label": "Tesla AI and Robotics",
        "url": "https://www.tesla.com/AI",
        "organization": "Tesla",
        "date": "accessed July 11, 2026",
        "documentTitle": "Tesla AI and Robotics"
      }
    ],
    "internalLinks": [
      {
        "label": "Browse the verified census of American humanoid companies",
        "path": "/robotics-news/american-humanoid-robot-companies"
      },
      {
        "label": "See which factory deployments are commercial, pilots or announcements",
        "path": "/robotics-news/humanoid-factory-deployments"
      },
      {
        "label": "Compare four prominent humanoid platforms",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      },
      {
        "label": "Review the cheapest humanoids with public prices",
        "path": "/robotics-news/cheapest-humanoid-robots"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "A split industrial scene showing verified Chinese and US humanoid production lines, labeled by company and metric.",
        "alt": "China and United States humanoid robot production lines compared with shipment and capacity labels",
        "source": "Official manufacturer media",
        "sourceUrl": "https://www.figure.ai/news/ramping-figure-03-production"
      },
      {
        "type": "Secondary image",
        "caption": "Unitree humanoid production and shipment clarification visual.",
        "alt": "Unitree humanoid robots arranged at a manufacturing facility",
        "source": "Unitree Robotics",
        "sourceUrl": "https://shop.unitree.com/blogs/news/clarification-regarding-unitrees-2025-sales-data"
      },
      {
        "type": "Secondary image",
        "caption": "AgiBot production milestone reported with its 20,000th robot on September 24, 2026.",
        "alt": "AgiBot production milestone associated with its twenty-thousandth robot",
        "source": "AgiBot",
        "sourceUrl": "https://www.agibot.com/article/231/detail/123.html"
      },
      {
        "type": "Secondary image",
        "caption": "Figure BotQ assembly line for Figure 03.",
        "alt": "Figure 03 humanoid robots moving through the BotQ production line",
        "source": "Figure AI",
        "sourceUrl": "https://www.figure.ai/news/ramping-figure-03-production"
      },
      {
        "type": "Original chart",
        "caption": "Six separate bars for capacity, manufactured, shipped, delivered, ordered and deployed units.",
        "alt": "Chart explaining the difference between humanoid robot capacity, production, shipments, deliveries, orders and deployments",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "Unitree separates more than 6,500 produced from more than 5,500 shipped in 2025.",
        "Figure reports more than 350 Figure 03 units delivered by April 2026.",
        "Agility’s 10,000 figure is factory peak capacity, not annual output."
      ],
      "unconfirmed": [
        "No audited 2025 or 2026 national humanoid production total exists for either country.",
        "The binding status and payment terms of many announced orders are not public.",
        "AgiBot’s portfolio production milestones cannot be reduced to full-size humanoids delivered without a model breakdown."
      ],
      "fastChanging": [
        "2026 production counters, new factories, order conversions and government programs can change monthly."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "what-home-robots-can-do",
    "slug": "what-home-robots-can-do",
    "path": "/robotics-news/what-home-robots-can-do",
    "title": "What Can a Home Robot Really Do in 2026?",
    "headline": "What Home Robots Can Reliably Do, and What Still Needs a Human",
    "seoTitle": "What Can a Home Robot Really Do in 2026? Task Audit",
    "description": "A task-by-task audit of home robots in 2026, separating reliable products, supervised work, controlled demonstrations, teleoperation and experiments today.",
    "category": "Home robotics",
    "datePublished": "2026-07-11",
    "dateModified": "2026-07-11",
    "readingTime": "17 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "what can a home robot do in 2026",
    "keywords": [
      "home robot tasks",
      "humanoid home robot",
      "robot laundry folding",
      "robot dishwasher loading",
      "1X NEO chores",
      "Sunday Memo robot",
      "Weave Isaac robot",
      "Figure home robot",
      "home robot autonomy"
    ],
    "searchQuestions": [
      "Can a robot clean a house in 2026?",
      "Can a humanoid load a dishwasher?",
      "Can robots fold laundry?",
      "Is 1X NEO autonomous?",
      "Which home robot can you buy?"
    ],
    "longTailKeywords": [
      "real home robot capabilities 2026",
      "robots that fold laundry at home",
      "autonomous dishwasher loading robot",
      "home humanoid robot reliability and price"
    ],
    "entities": [
      "1X NEO",
      "Sunday Memo",
      "Weave Isaac",
      "Figure 03",
      "Helix 02",
      "Physical Intelligence",
      "ALOHA",
      "Toyota Human Support Robot"
    ],
    "introduction": [
      "A home robot can already vacuum a floor for an hour without an operator. The same standard does not yet apply to clearing a mixed dinner table, sorting laundry or loading an unfamiliar dishwasher. In 2026, the strongest general-manipulation demonstrations include Sunday Memo handling dishes and socks, Figure 03 completing an uncut dishwasher sequence, Physical Intelligence policies folding laundry and 1X NEO performing household chores with a combination of autonomy and Expert Mode. Each result uses a different body, home, speed and intervention policy.",
      "This audit counts only tasks shown in a real home or a credible domestic setup. It separates specialized products that work reliably today from supervised systems, controlled demonstrations, teleoperated sequences and experiments. Company labels are retained, but a video is not accepted as proof of everyday reliability unless the source reports repetition, duration, success rate or field use. Price and availability are also separated a beta application, deposit, subscription and normal retail shipment are four different commercial states."
    ],
    "keyFindings": [
      "Specialized floor cleaning is reliable today; general household manipulation is not.",
      "Laundry folding has moved beyond one-off clips, but current systems remain slow, task-specific or limited to selected households.",
      "Dishwasher loading is demonstrated by Memo and Figure, yet neither source provides a standardized household success rate across many kitchens.",
      "1X NEO is the clearest purchasable full-body home proposition, but its offer explicitly includes human Expert Mode.",
      "Elder care remains experimental because physical safety, clinical validation, privacy and emergency reliability are not established."
    ],
    "comparisonTables": [
      {
        "id": "home-task-evidence",
        "title": "What home robots can do in 2026",
        "description": "Classification concerns the cited task, not every capability of the robot.",
        "columns": [
          "Task and system",
          "Environment and evidence",
          "Autonomy class",
          "Availability and price",
          "Practical limitation"
        ],
        "rows": [
          [
            "Floor vacuuming and mopping; specialized mobile cleaners",
            "Millions of homes; routine navigation, docking and scheduled cleaning are established product functions.",
            "Autonomous for the bounded task",
            "Widely sold at consumer prices",
            "Corners, stairs, cables, liquids and object pickup still require preparation or human help."
          ],
          [
            "Laundry folding; Weave Isaac 0",
            "Limited California household service; Weave reports more than 2,000 field hours and over 1,000 pounds of laundry per week.",
            "Supervised autonomous",
            "$249 per month with no upfront payment, or $3,999 plus $49 per month; regional program",
            "Stationary appliance dedicated mainly to laundry; service area and garment range are limited."
          ],
          [
            "Laundry and mobile chores; Weave Isaac 1",
            "Company demonstrations and fall-2026 California reservation program.",
            "Supervised autonomous; intervention policy not fully published",
            "$449 per month or $7,999 upfront; $250 refundable reservation",
            "Shipping schedule, generalization and real-home success rates remain unverified."
          ],
          [
            "Dishes, espresso and socks; Sunday Memo",
            "Company-published uncut and accelerated clips in homes, plus training-data collection through gloves.",
            "Company labels execution autonomous; independent evidence unavailable",
            "Free late-2026 beta application; no retail sale or final price",
            "Reliability is still being improved; beta households are part of product development."
          ],
          [
            "Dishwasher loading; Figure 03 with Helix 02",
            "Company says a four-minute sequence was autonomous and uncut.",
            "Autonomous, according to Figure",
            "Not sold to consumers",
            "One curated kitchen and company-produced evidence do not establish broad household reliability."
          ],
          [
            "Bedroom tidying; Figure 03 with Helix 02",
            "Company demonstration of object pickup and placement in a furnished room.",
            "Autonomous, according to Figure",
            "Not sold to consumers",
            "Object set, intervention log and repeated success rate are not independently published."
          ],
          [
            "General chores; 1X NEO",
            "Home product page and demonstrations; foundational autonomy plus remote Expert Mode.",
            "Human-in-the-loop with autonomous skills",
            "$20,000 Early Access or $499 per month; $200 refundable deposit, US delivery plan",
            "Experts may need to help with unfamiliar chores; privacy and service terms matter."
          ],
          [
            "Laundry and kitchen manipulation; Physical Intelligence policies",
            "Research videos and uncut demonstrations on robot platforms, including operation in new homes.",
            "Autonomous research execution after training",
            "Model research, not a consumer robot",
            "Policy performance depends on hardware, scene setup and task distribution."
          ],
          [
            "Assistance and object retrieval; Toyota HSR",
            "Research and demonstration programs in human environments.",
            "Teleoperated, supervised autonomous or research policy depending on project",
            "Research platform, not mass-market home product",
            "No single current consumer package or universal autonomy level."
          ]
        ]
      },
      {
        "id": "task-reliability-bands",
        "title": "Task classification by current evidence",
        "description": "The same task can move between categories depending on the robot and environment.",
        "columns": [
          "Band",
          "Examples",
          "Evidence required"
        ],
        "rows": [
          [
            "Reliable today",
            "Bounded floor cleaning, scheduled patrol and automatic docking by specialized products",
            "Repeated consumer use, product support and minimal operator intervention"
          ],
          [
            "Possible under supervision",
            "Laundry handling, object retrieval, simple transport and selected door operations",
            "Field use with monitoring, recovery support or a restricted object set"
          ],
          [
            "Controlled demonstration",
            "Dishwasher loading, table clearing, sock folding and simple food-machine operation",
            "A successful company or laboratory sequence in a prepared or familiar environment"
          ],
          [
            "Teleoperated",
            "Remote manipulation, training demonstrations and rescue from an unfamiliar state",
            "Human motion, joystick, VR or remote expert directly influences execution"
          ],
          [
            "Experimental",
            "General cooking, mixed-clutter cleanup, shower or toileting assistance",
            "Early research without sufficient safety, repeatability or product evidence"
          ],
          [
            "Not yet reliable",
            "Unsupervised whole-home housekeeping and physical elder care",
            "No public system meets broad task coverage, safety and recovery requirements"
          ]
        ]
      }
    ],
    "sections": [
      {
        "heading": "Floor cleaning is the benchmark for household autonomy",
        "paragraphs": [
          "Robot vacuums succeed because the task is narrow move over a mostly horizontal floor, avoid obstacles, collect debris and return to a dock. The environment can be mapped and the tool stays near the ground. Even here, users still remove cords, unblock brushes and handle stairs. The product is autonomous for a bounded workflow, not a general household agent.",
          "General-purpose robots inherit every difficult part that floor cleaners avoid. They must identify objects, select a grasp, estimate fragility, carry items at human worktop height, open mechanisms and recover after slips. A home also changes between runs. Reliability therefore drops as soon as the robot must manipulate unstructured objects rather than navigate around them."
        ]
      },
      {
        "heading": "Laundry is becoming a real service, but not a solved skill",
        "paragraphs": [
          "Weave’s Isaac 0 is the strongest field-use claim in this sample because the company publishes cumulative hours and laundry volume and offers a limited California service. Its stationary architecture removes walking, doorways and whole-home navigation, narrowing the problem to handling garments around one appliance. That design choice is a practical advantage, not a weakness.",
          "Physical Intelligence and other laboratories show autonomous folding policies across garments, while Sunday Memo demonstrates piles of socks. These clips establish capability. They do not establish that every fabric, inside-out sleeve, wet garment or tangled load will finish without assistance. A useful home product needs recovery and service support as much as a successful grasp policy."
        ]
      },
      {
        "heading": "Dishwashers expose the gap between a demo and a product",
        "paragraphs": [
          "Figure’s Helix 02 dishwasher sequence is valuable because the company describes it as autonomous and uncut. Sunday also publishes Memo sequences for clearing dishes, dumping scraps and loading a machine. Both show multi-step coordination, fragile-object handling and appliance interaction.",
          "The missing evidence is distribution. Kitchens vary in lighting, counter height, dishwasher racks, plate shape and clutter. Neither company publishes a standardized test across dozens of homes with intervention counts and breakage rates. The correct classification is a demonstrated autonomous task under the company’s conditions, not reliable universal dishwasher loading."
        ]
      },
      {
        "heading": "Food preparation remains narrow",
        "paragraphs": [
          "Memo can operate an espresso machine in a company demonstration, and laboratory robots can pour or manipulate ingredients. Those are bounded procedures with known tools. General cooking adds heat, sharp objects, contamination, timing and continuous safety monitoring. A robot that can make one espresso has not demonstrated meal preparation.",
          "Food service should be described at the operation level fetch a sealed drink, press a machine control, pour from a known container or move a plate. Each action needs its own success and safety evidence. No reviewed general home robot publishes broad independent results for cooking complete meals."
        ]
      },
      {
        "heading": "Human assistance is part of the product architecture",
        "paragraphs": [
          "1X makes the human-in-the-loop layer explicit through Expert Mode. That is more transparent than presenting every successful chore as independent autonomy. A remote expert can recover a task, demonstrate a new one or operate the robot while the system collects useful data. Reflex and other industrial companies use similar supervision logic for uptime.",
          "For a home buyer, the important questions are who can access cameras, when a human takes control, whether consent is per session, where video is processed and what happens if connectivity fails. Autonomy percentage alone does not answer those privacy and service questions."
        ]
      },
      {
        "heading": "Elder assistance needs a higher evidence standard",
        "paragraphs": [
          "Voice reminders, remote check-ins and fetching light objects are plausible low-contact tasks. Physical support, fall recovery, medication handling, bathing and emergency response carry medical and injury risks. A robot must detect failure, avoid pulling a person off balance and remain available during power or network faults.",
          "None of the general home robots reviewed publishes clinical validation or a broad safety case for unsupervised physical elder care. Such claims should remain experimental until healthcare partners report defined tasks, population, observation period, adverse events and human oversight."
        ]
      }
    ],
    "limitations": [
      "Company-produced videos may omit failed attempts, setup time and off-camera intervention even when the visible sequence is uncut.",
      "Task duration and success rates are rarely reported under a common protocol.",
      "Prices can exclude subscription, remote assistance, delivery, installation, taxes or regional service limits.",
      "A research policy demonstrated on one robot does not become a consumer product until hardware, support and safety are integrated.",
      "Specialized appliances and complete mobile humanoids solve different problems and should not be ranked as if they were interchangeable."
    ],
    "conclusion": [
      "A home robot in 2026 can reliably perform narrow, well-engineered jobs. Floor cleaning is established. Weave’s stationary Isaac 0 shows that laundry can become a regional service when mobility is removed from the problem. Memo, Figure 03, NEO and research policies demonstrate pieces of table clearing, dishwasher loading, folding, object retrieval and appliance operation, but their evidence does not yet support unsupervised whole-home housekeeping.",
      "The most honest commercial architecture is supervised. A robot executes known skills, asks for help when confidence falls and records intervention instead of hiding it. NEO’s Expert Mode states that model directly. Buyers should judge each task by repetition, environment diversity, intervention rate, damage risk and service coverage. Under that standard, general cooking, mixed-clutter cleanup and physical elder care remain experimental, while bounded cleaning, laundry and object transport are the first areas moving from video demonstrations toward usable household systems."
    ],
    "faqs": [
      {
        "question": "Can a home robot clean an entire house in 2026?",
        "answer": "Specialized robots can vacuum or mop mapped floors, but no reviewed general-purpose robot reliably handles every room, surface and object without preparation or assistance. Picking up mixed clutter, cleaning bathrooms, moving between floors and handling liquids require manipulation and recovery capabilities that current home platforms have demonstrated only in narrower conditions."
      },
      {
        "question": "Can a robot fold laundry automatically?",
        "answer": "Yes, selected robots and research policies can fold garments autonomously. Weave reports limited real-home operation with Isaac 0, while Physical Intelligence and Sunday publish folding demonstrations. The capability is still constrained by garment type, presentation, speed and recovery. A successful sequence should not be read as universal handling of tangled or highly varied laundry."
      },
      {
        "question": "Can a humanoid robot load a dishwasher?",
        "answer": "Figure 03 and Sunday Memo have company-published dishwasher demonstrations. Figure describes one four-minute Helix 02 sequence as autonomous and uncut. The evidence shows the task is technically possible under those conditions. It does not establish a standardized success rate across different racks, kitchens, dishes and lighting, so everyday reliability remains unproven."
      },
      {
        "question": "Is 1X NEO autonomous or teleoperated?",
        "answer": "NEO combines autonomous skills with a human-in-the-loop service. 1X says the robot arrives with foundational autonomy and can use Expert Mode when help is needed. That may involve remote human operation or demonstration. The correct label is therefore mixed autonomous for some skills and human-assisted for tasks outside the current capability set."
      },
      {
        "question": "Which general home robot can I buy in 2026?",
        "answer": "1X publishes a NEO Early Access ownership price and monthly option with a refundable deposit. Weave offers Isaac 0 in a limited California program and reservations for Isaac 1. Sunday Memo remains a free beta application rather than a retail sale. Availability depends on region, service coverage and the difference between reservation and shipment."
      },
      {
        "question": "Are home robots safe for elderly users?",
        "answer": "Current robots may support reminders, communication or light object retrieval under supervision. Unsupervised physical assistance is a different risk category. No system reviewed here publishes broad clinical evidence for lifting people, preventing falls or handling medication independently. Families should not treat a consumer robot demonstration as certified medical or emergency-care capability."
      }
    ],
    "methodology": [
      "Only official demonstrations or research pages showing domestic tasks in real homes or credible household setups were included. Each entry was classified by autonomy evidence, commercial status and environmental scope. Specialized floor cleaners are used as a reliability benchmark but not counted as humanoids.",
      "Verification date July 11, 2026. Company success claims remain company-reported unless a field metric or independent study is identified. Missing intervention rates and failure data are stated rather than estimated."
    ],
    "sourceLinks": [
      {
        "label": "NEO product page",
        "url": "https://www.1x.tech/neo",
        "organization": "1X Technologies",
        "date": "accessed July 11, 2026",
        "documentTitle": "NEO product page"
      },
      {
        "label": "NEO order program",
        "url": "https://www.1x.tech/order",
        "organization": "1X Technologies",
        "date": "accessed July 11, 2026",
        "documentTitle": "NEO order program"
      },
      {
        "label": "Sunday Memo home robot",
        "url": "https://www.sunday.ai/",
        "organization": "Sunday Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Sunday Memo home robot"
      },
      {
        "label": "Sunday 2026 Beta Program",
        "url": "https://www.sunday.ai/beta-program",
        "organization": "Sunday Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Sunday 2026 Beta Program"
      },
      {
        "label": "Weave Robotics home page",
        "url": "https://www.weaverobotics.com/",
        "organization": "Weave Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Weave Robotics home page"
      },
      {
        "label": "Isaac 0 order page",
        "url": "https://www.weaverobotics.com/isaac-0/order",
        "organization": "Weave Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Isaac 0 order page"
      },
      {
        "label": "Isaac 1 order page",
        "url": "https://www.weaverobotics.com/isaac-1/order",
        "organization": "Weave Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Isaac 1 order page"
      },
      {
        "label": "Helix 02 Full-Body Autonomy",
        "url": "https://www.figure.ai/news/helix-02",
        "organization": "Figure AI",
        "date": "2026",
        "documentTitle": "Helix 02 Full-Body Autonomy"
      },
      {
        "label": "Helix 02 Bedroom Tidy",
        "url": "https://www.figure.ai/news/helix-02-bedroom-tidy",
        "organization": "Figure AI",
        "date": "2026",
        "documentTitle": "Helix 02 Bedroom Tidy"
      },
      {
        "label": "π0.5 a VLA model that learns from experience",
        "url": "https://www.physicalintelligence.company/blog/pi05",
        "organization": "Physical Intelligence",
        "date": "2025",
        "documentTitle": "π0.5 a VLA model that learns from experience"
      },
      {
        "label": "Our robots are learning to fold laundry",
        "url": "https://www.physicalintelligence.company/blog/our-robots-are-learning-to-fold-laundry",
        "organization": "Physical Intelligence",
        "date": "2025",
        "documentTitle": "Our robots are learning to fold laundry"
      },
      {
        "label": "Advances in robot dexterity",
        "url": "https://deepmind.google/blog/advances-in-robot-dexterity/",
        "organization": "Google DeepMind",
        "date": "2024",
        "documentTitle": "Advances in robot dexterity"
      },
      {
        "label": "Toyota Human Support Robot",
        "url": "https://global.toyota/en/detail/8709541",
        "organization": "Toyota Motor Corporation",
        "date": "2015",
        "documentTitle": "Toyota Human Support Robot"
      }
    ],
    "internalLinks": [
      {
        "label": "Compare NEO with Tesla Optimus, Figure 03 and Unitree G1",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      },
      {
        "label": "Check which humanoid robots have verifiable purchase prices",
        "path": "/robotics-news/cheapest-humanoid-robots"
      },
      {
        "label": "Use the autonomy versus teleoperation video checklist",
        "path": "/robotics-news/autonomous-vs-teleoperated-robot-guide"
      },
      {
        "label": "See the models that connect perception to robot action",
        "path": "/robotics-news/physical-ai-model-map"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "A real home scene with NEO, Memo, Isaac and Figure 03 labeled by task and autonomy class.",
        "alt": "Home robots performing laundry, dishwasher and object-retrieval tasks with evidence labels",
        "source": "Official manufacturer media",
        "sourceUrl": "https://www.sunday.ai/"
      },
      {
        "type": "Secondary image",
        "caption": "Sunday Memo clearing a dining table in the company’s uncut sequence.",
        "alt": "Sunday Memo wheeled home robot collecting dishes from a dining table",
        "source": "Sunday Robotics",
        "sourceUrl": "https://www.sunday.ai/"
      },
      {
        "type": "Secondary image",
        "caption": "Weave Isaac 0 folding laundry at its stationary household workstation.",
        "alt": "Weave Isaac 0 robot folding household laundry",
        "source": "Weave Robotics",
        "sourceUrl": "https://www.weaverobotics.com/"
      },
      {
        "type": "Secondary image",
        "caption": "Figure 03 loading a dishwasher with Helix 02.",
        "alt": "Figure 03 humanoid robot loading dishes into a dishwasher",
        "source": "Figure AI",
        "sourceUrl": "https://www.figure.ai/news/helix-02"
      },
      {
        "type": "Original chart",
        "caption": "Task matrix from reliable today to not yet reliable, with intervention icons.",
        "alt": "Home robot task reliability matrix for cleaning, laundry, dishes, food, retrieval and elder assistance",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "Sunday states Memo is not for purchase until after its 2026 beta.",
        "1X publishes NEO ownership, monthly and refundable-deposit terms.",
        "Weave publishes separate Isaac 0 and Isaac 1 prices and regional schedules."
      ],
      "unconfirmed": [
        "No common success-rate benchmark covers the cited household tasks.",
        "Independent validation of Memo and Figure home demonstrations is unavailable.",
        "The extent of remote intervention for each commercial home-robot session is not fully public."
      ],
      "fastChanging": [
        "Beta schedules, regional availability, subscription terms and learned task libraries can change during 2026."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "physical-ai-model-map",
    "slug": "physical-ai-model-map",
    "path": "/robotics-news/physical-ai-model-map",
    "title": "Physical AI Model Map: Roles, Access and Control",
    "headline": "A Practical Map of the Models That Turn Perception Into Robot Action",
    "seoTitle": "Physical AI Model Map: Policies, Reasoning and World Models",
    "description": "A structured map of Physical AI models covering VLA policies, embodied reasoning, world models, manipulation, locomotion, tactile learning and simulation.",
    "category": "Physical AI models",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "18 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "Physical AI model map",
    "keywords": [
      "vision-language-action models",
      "robotics foundation models",
      "world models for robotics",
      "embodied reasoning models",
      "robot manipulation policies",
      "robot locomotion policies",
      "tactile models",
      "multimodal robot control",
      "robot simulation models"
    ],
    "searchQuestions": [
      "What is a Physical AI model?",
      "What is a vision-language-action model?",
      "Is a world model a robot policy?",
      "Which robotics foundation models are open source?",
      "How do robot perception and control models connect?"
    ],
    "longTailKeywords": [
      "complete map of robotics foundation models",
      "open source vision language action models 2026",
      "physical AI perception planning action stack",
      "world models versus robot control policies"
    ],
    "entities": [
      "NVIDIA Isaac GR00T",
      "Gemini Robotics",
      "Physical Intelligence π0",
      "OpenVLA",
      "Octo",
      "RT-2",
      "Figure Helix",
      "1X Redwood",
      "Skild Brain",
      "NVIDIA Cosmos",
      "Open X-Embodiment"
    ],
    "introduction": [
      "A language model can describe how to load a dishwasher without producing a single motor command. A robot policy can output joint actions without understanding why the plate belongs in a rack. A world model can predict what a future scene may look like without controlling real hardware. Physical AI is the stack that connects these separate functions sensing, representation, reasoning, planning, action generation, low-level control, safety and recovery.",
      "The term is often used so broadly that simulators, video generators, perception networks and complete robot brains appear in one undifferentiated list. This map separates them by input, output and role. The explanatory catalog uses selected historical versions, including NVIDIA Isaac GR00T 1.7, Gemini Robotics, Gemini Robotics-ER 1.6, π0 and π0.5, OpenVLA, Octo, RT-2, Figure Helix 02 and 1X Redwood. “Open” is also divided into weights, code, data and license because those are not the same form of access."
    ],
    "keyFindings": [
      "A VLA model converts visual observations and language instructions into actions; an embodied reasoning model may plan and verify without directly controlling joints.",
      "World models generate or predict future states and data. They support planning and training but are not automatically deployable robot policies.",
      "OpenVLA, Octo, openpi and NVIDIA’s GR00T releases provide different combinations of code, weights and licenses; none is plug-and-play across every robot.",
      "Figure Helix and 1X Redwood are vertically integrated proprietary policies tied to each company’s hardware and data pipeline.",
      "The largest missing layer in public benchmarks is long-duration recovery most evaluations measure task success, not intervention rate across real shifts."
    ],
    "comparisonTables": [
  {
    "id": "physical-ai-model-catalog",
    "title": "Major Physical AI models and their roles",
    "description": "This catalog explains roles using named historical versions. The model tracker above contains separately maintained records; neither is a complete census or a shared benchmark. Access depends on the released component and license.",
    "columns": [
      "Model",
      "Organization / date",
      "Category",
      "Inputs → outputs",
      "Hardware or task evidence",
      "Access and main limitation"
    ],
    "rows": [
      [
        "Isaac GR00T 1.7",
        "NVIDIA; July 2026",
        "Open reasoning VLA / humanoid policy",
        "Images, language and robot state → action trajectories",
        "Humanoid manipulation, finger control and cross-embodiment workflows through Isaac Lab and ROS",
        "Weights and code available under NVIDIA terms; still requires robot-specific data, tuning and safety integration"
      ],
      [
        "Gemini Robotics 1.5",
        "Google DeepMind; named historical version",
        "VLA / multimodal control",
        "Image, text, audio or video context → robot actions",
        "Dexterous manipulation and multi-step physical tasks on several robot forms",
        "Closed service and selected access; hardware latency, cost and deployment details vary"
      ],
      [
        "Gemini Robotics-ER 1.6",
        "Google DeepMind; 2026",
        "Embodied reasoning and orchestration",
        "Multi-view perception, language and tools → plans, spatial references and success decisions",
        "Task planning, instrument reading, pointing and retry/progress logic",
        "Available through Google tooling; it is a high-level brain, not a universal low-level controller"
      ],
      [
        "Gemini Robotics On-Device",
        "Google DeepMind; 2026",
        "On-device VLA",
        "Image, text and action context → actions",
        "Local dexterous manipulation and adaptation",
        "Private preview / trusted testers; model weights and broad benchmarks are not public"
      ],
      [
        "π0",
        "Physical Intelligence; October 2024",
        "Generalist VLA policy",
        "Images, language and proprioception → continuous actions",
        "Multi-robot manipulation including laundry, boxes and table tasks",
        "Base weights and code through openpi; substantial fine-tuning and hardware integration required"
      ],
      [
        "π0.5",
        "Physical Intelligence; April 2025",
        "Open-world VLA policy",
        "Visual observations, language and robot state → actions",
        "Generalization to new homes and semantically varied chores",
        "Code and π0.5 checkpoints are public in openpi; target-robot integration remains necessary"
      ],
      [
        "OpenVLA 7B",
        "Stanford, UC Berkeley and collaborators; June 2024",
        "Open-source VLA",
        "Image and language → tokenized robot actions",
        "BridgeData V2 and LIBERO manipulation evaluations",
        "Code and weights open; action representation and embodiment transfer need adaptation"
      ],
      [
        "Octo",
        "UC Berkeley and collaborators; 2024",
        "Generalist robot policy",
        "Images, language and task observations → action chunks",
        "Fine-tuning across multiple robot datasets and embodiments",
        "Open code and checkpoints; performance depends heavily on dataset and embodiment match"
      ],
      [
        "RT-2",
        "Google DeepMind; July 2023",
        "VLA",
        "Images and text → action tokens",
        "Semantic manipulation and web-knowledge transfer on robot tasks",
        "Closed model; useful historical foundation but not a downloadable general platform"
      ],
      [
        "Helix 02",
        "Figure AI; 2026",
        "Proprietary full-body VLA / control hierarchy",
        "Robot cameras, language and state → upper-body and locomotion actions",
        "Figure 03 dishwasher, room-tidying and industrial tasks",
        "Closed and tied to Figure hardware; benchmarks and intervention logs are company-controlled"
      ],
      [
        "Redwood AI",
        "1X Technologies; 2025-2026",
        "Proprietary home-robot policy",
        "Vision, language and robot state → NEO actions",
        "Household skills and data collection on NEO",
        "Closed; Expert Mode means human assistance remains part of product operation"
      ],
      [
        "Skild Brain",
        "Skild AI; source version recorded below",
        "Cross-embodiment robotics foundation model",
        "Multimodal observations and instructions → robot policies",
        "Claims across manipulation, locomotion and different embodiments",
        "Closed commercial access; public architecture and benchmark detail remain limited"
      ],
      [
        "Cosmos world foundation models",
        "NVIDIA; 2025-2026",
        "World models and synthetic data",
        "Video, text and physical scene context → predicted or generated video/world states",
        "Data generation, scenario expansion and robot training support",
        "Models and tools vary by release; output is not a motor policy without a downstream controller"
      ],
      [
        "Open X-Embodiment / RT-X",
        "Google DeepMind and 20+ institutions; 2023",
        "Dataset mixture and cross-robot policy research",
        "Multi-robot trajectories → training data for generalist policies",
        "Shared data from many robot embodiments and RT-X experiments",
        "Dataset heterogeneity, licenses and action normalization complicate reuse"
      ]
    ]
  },
  {
    "id": "physical-ai-taxonomy",
    "title": "Taxonomy from data to motion",
    "description": "Each layer answers a different question and passes a different output to the next stage.",
    "columns": [
      "Layer",
      "Question answered",
      "Examples",
      "Output passed downstream"
    ],
    "rows": [
      [
        "Data and simulation",
        "What experiences can the system learn from?",
        "Open X-Embodiment, Isaac Lab, teleoperation datasets, Cosmos-generated scenarios",
        "Trajectories, labels, synthetic scenes and demonstrations"
      ],
      [
        "Perception and tactile representation",
        "What objects, contacts and body states exist now?",
        "Vision encoders, depth models, Sparsh-style tactile representations",
        "Features, poses, contact state and uncertainty"
      ],
      [
        "World model",
        "What may happen next?",
        "NVIDIA Cosmos and learned dynamics models",
        "Predicted future states or generated rollouts"
      ],
      [
        "Embodied reasoning",
        "What is the task, constraint and next subgoal?",
        "Gemini Robotics-ER and high-level planners",
        "Plan, spatial grounding, tool call or success judgment"
      ],
      [
        "VLA / action policy",
        "Which action sequence should execute the instruction?",
        "GR00T, Gemini Robotics, π0, OpenVLA, Octo, Helix, Redwood",
        "End-effector targets, action chunks or joint-level commands"
      ],
      [
        "Low-level manipulation and locomotion",
        "How should motors track the target while maintaining contact and balance?",
        "Whole-body controllers, reinforcement-learning locomotion policies, impedance control",
        "Torque, position or velocity commands"
      ],
      [
        "Safety, recovery and supervision",
        "Should the robot continue, retry, stop or ask for help?",
        "Collision limits, fall detection, remote assistance and success detectors",
        "Stop, retry, reduced-speed mode or human handoff"
      ]
    ]
  }
],
    "sections": [
      {
        "heading": "Vision-language-action models are policies, not complete robots",
        "paragraphs": [
          "A VLA model receives visual observations and an instruction, then predicts actions. Those actions can be Cartesian gripper targets, joint commands or tokenized trajectories. The model still depends on calibrated cameras, robot kinematics, a real-time controller, collision handling and a safe execution layer. A checkpoint trained on one arm cannot be assumed to control a biped because action spaces, timing and body dynamics differ.",
          "OpenVLA, Octo and openpi give researchers inspectable starting points. NVIDIA GR00T adds a broader humanoid development workflow around teleoperation, simulation, training, evaluation and deployment. Gemini Robotics and proprietary systems such as Helix integrate reasoning and action more tightly but expose less implementation detail."
        ]
      },
      {
        "heading": "Embodied reasoning sits above continuous control",
        "paragraphs": [
          "Gemini Robotics-ER 1.6 is a useful example of a high-level model. It reasons about multi-view scenes, selects subgoals, interprets instruments and checks whether a step succeeded. It can orchestrate tools and decide to retry. That output can guide a policy, but it is not a replacement for a stable controller running at motor frequency.",
          "This distinction matters when companies call a model a robot brain. A planner operating once per second and a torque controller operating hundreds or thousands of times per second are both necessary, yet they solve different problems. Public model maps should label the temporal and control level instead of placing every model in one “intelligence” box."
        ]
      },
      {
        "heading": "World models produce futures, not necessarily actions",
        "paragraphs": [
          "World models learn how scenes may evolve. They can generate synthetic training clips, predict the effect of a candidate action or expose rare failure states in simulation. NVIDIA Cosmos is positioned as a family of world foundation models supporting physical AI data and simulation. A generated future can improve a policy, but the model does not become a deployable controller unless a planner or action policy consumes that prediction.",
          "Video-generation quality is also not physical validity. Contact forces, friction, object mass and actuator limits can be visually plausible while mechanically wrong. Real-robot validation remains necessary, especially for dexterous manipulation and dynamic balance."
        ]
      },
      {
        "heading": "Manipulation, locomotion and touch need specialized layers",
        "paragraphs": [
          "Generalist VLAs focus attention on semantic tasks, yet hand contact and biped balance are sensitive to milliseconds, force and local geometry. Many systems therefore pair a large model with specialized manipulation controllers, tactile estimators and reinforcement-learning locomotion policies. The large model selects an objective; lower layers execute it under physical constraints.",
          "Tactile learning remains underrepresented in public foundation-model maps. Camera-based touch sensors can produce dense images, while force-torque sensors provide lower-dimensional contact signals. The model must synchronize those streams with vision and proprioception. Few public benchmarks compare tactile generalization across different hands."
        ]
      },
      {
        "heading": "Open source has four separate meanings",
        "paragraphs": [
          "A project can release a paper without code, code without weights, weights without training data or all three under a license that restricts commercial use. OpenVLA and openpi provide meaningful code and checkpoint access. GR00T publishes code and weights under NVIDIA terms. Gemini Robotics, Helix, Redwood and Skild Brain remain controlled commercial systems.",
          "Dataset access is equally important. Open X-Embodiment demonstrated the value of pooled robot trajectories, but heterogeneous sensors, coordinate frames and licenses make mixture training difficult. A model being downloadable does not remove the cost of collecting task-specific demonstrations on the target robot."
        ]
      },
      {
        "heading": "Benchmarks still miss operational reliability",
        "paragraphs": [
          "LIBERO, BridgeData evaluations and laboratory task suites measure progress, but factories and homes need longer metrics tasks per hour, intervention rate, recovery time, damage, safety stops and performance after lighting or object changes. A model can score well on short episodes and still fail repeatedly during a shift.",
          "The next useful comparison should report policy success together with robot embodiment, control frequency, scene distribution, number of trials and human recovery. Without those fields, claims of generality remain difficult to compare across organizations."
        ]
      }
    ],
    "limitations": [
      "The map prioritizes influential and currently accessible systems; it is not a list of every robotics model published worldwide.",
      "Organizations disclose architecture, training data and benchmarks at different levels of detail.",
      "Model names can cover several checkpoints or product versions, and access terms may change.",
      "Simulation tools such as Isaac Lab are included only as pipeline layers, not mislabeled as robot policies.",
      "No common benchmark compares all models on the same hardware, tasks, intervention rules and safety constraints."
    ],
    "conclusion": [
      "Physical AI is a pipeline, not one giant model. Perception encodes the scene. A world model estimates possible futures. Embodied reasoning turns a goal into subgoals and checks progress. A VLA or specialized policy produces actions. Low-level controllers maintain contact, balance and timing. Safety and supervision decide when to stop or ask for help. Systems such as GR00T, Gemini Robotics, π0, OpenVLA, Helix and Redwood occupy different parts of that stack even when their marketing language overlaps.",
      "For developers, model choice begins with the output required by the robot. A high-level planner is useful when task decomposition is the bottleneck. An open VLA is useful when the team can collect embodiment-specific data and tune the action space. A world model is useful for prediction and synthetic experience. None removes the need for controllers, calibration, safety and field evaluation. The most informative 2026 model map therefore labels role, access, embodiment and evidence rather than declaring a single “best robot brain.”"
    ],
    "faqs": [
      {
        "question": "What is a Physical AI model?",
        "answer": "A Physical AI model processes information about the physical world and contributes to perception, reasoning, planning, prediction or control. The term can include VLAs, world models, tactile encoders and locomotion policies. It should not imply that one model performs every layer from camera input to safe motor torque."
      },
      {
        "question": "What is a vision-language-action model?",
        "answer": "A VLA takes visual observations and language instructions and predicts robot actions. Actions may be tokenized, continuous end-effector targets or joint trajectories. A VLA still needs robot-specific calibration, control, safety and often fine-tuning. It is closer to a task policy than to a complete autonomous robot product."
      },
      {
        "question": "Is a robotics world model the same as a robot policy?",
        "answer": "No. A world model predicts or generates possible future states. A policy selects actions. A planning system can use a world model to compare candidate actions, but generated video or predicted state alone does not move a robot. Some systems combine both functions, so architecture and outputs must be checked."
      },
      {
        "question": "Which Physical AI models are open source?",
        "answer": "OpenVLA, Octo, openpi and NVIDIA Isaac GR00T provide substantial public code or weights, though licenses and completeness differ. Open X-Embodiment provides datasets and research tooling. Gemini Robotics, Figure Helix, 1X Redwood and Skild Brain are controlled-access or proprietary systems. Open code does not guarantee open training data."
      },
      {
        "question": "Can the same model control any robot?",
        "answer": "Cross-embodiment models aim to transfer knowledge, but robots differ in cameras, joints, hands, timing, payload and safety limits. Most models require action-space adapters, demonstrations and fine-tuning for a target platform. General semantic knowledge transfers more easily than precise contact-rich control or dynamic locomotion."
      },
      {
        "question": "Why are simulators not classified as models?",
        "answer": "A simulator computes how a virtual environment changes under actions. It can generate data and evaluate policies, but it is not itself the learned policy. Learned world models can overlap with simulation, yet tools such as Isaac Lab remain environments and workflows. Keeping the categories separate prevents software infrastructure from being counted as robot intelligence."
      }
    ],
    "methodology": [
  "Models are classified by inputs, outputs and role. Code, weights, data and commercial access are separate fields.",
  "The explanatory catalog retains named historical versions and source dates. The October 11, 2026 correction updates π0.5 availability from openpi and removes a completeness claim; it does not certify every model as the latest version."
],
    "sourceLinks": [
  {
    "label": "Develop Humanoid Robot Policies End-to-End with NVIDIA Isaac GR00T",
    "url": "https://developer.nvidia.com/blog/develop-humanoid-robot-policies-end-to-end-with-nvidia-isaac-gr00t/",
    "organization": "NVIDIA",
    "date": "July 2026",
    "documentTitle": "Develop Humanoid Robot Policies End-to-End with NVIDIA Isaac GR00T"
  },
  {
    "label": "Isaac GR00T platform",
    "url": "https://developer.nvidia.com/isaac/gr00t",
    "organization": "NVIDIA",
    "date": "accessed July 11, 2026",
    "documentTitle": "Isaac GR00T platform"
  },
  {
    "label": "Gemini Robotics",
    "url": "https://deepmind.google/models/gemini-robotics/",
    "organization": "Google DeepMind",
    "date": "accessed July 11, 2026",
    "documentTitle": "Gemini Robotics"
  },
  {
    "label": "Gemini Robotics-ER 1.6",
    "url": "https://deepmind.google/models/gemini-robotics/gemini-robotics-er/",
    "organization": "Google DeepMind",
    "date": "accessed July 11, 2026",
    "documentTitle": "Gemini Robotics-ER 1.6"
  },
  {
    "label": "Gemini Robotics On-Device",
    "url": "https://deepmind.google/models/gemini-robotics/gemini-robotics-on-device/",
    "organization": "Google DeepMind",
    "date": "accessed July 11, 2026",
    "documentTitle": "Gemini Robotics On-Device"
  },
  {
    "label": "π0 Our First Generalist Policy",
    "url": "https://physicalintelligence.company/blog/pi0",
    "organization": "Physical Intelligence",
    "date": "October 31, 2024",
    "documentTitle": "π0 Our First Generalist Policy"
  },
  {
    "label": "Open Sourcing π0",
    "url": "https://www.physicalintelligence.company/blog/openpi",
    "organization": "Physical Intelligence",
    "date": "February 4, 2025",
    "documentTitle": "Open Sourcing π0"
  },
  {
    "label": "π0.5 A VLA with Open-World Generalization",
    "url": "https://www.physicalintelligence.company/blog/pi05",
    "organization": "Physical Intelligence",
    "date": "April 22, 2025",
    "documentTitle": "π0.5 A VLA with Open-World Generalization"
  },
  {
    "label": "OpenVLA repository",
    "url": "https://github.com/openvla/openvla",
    "organization": "OpenVLA project",
    "date": "accessed July 11, 2026",
    "documentTitle": "OpenVLA repository"
  },
  {
    "label": "Octo project",
    "url": "https://octo-models.github.io/",
    "organization": "Octo project",
    "date": "accessed July 11, 2026",
    "documentTitle": "Octo project"
  },
  {
    "label": "RT-2",
    "url": "https://deepmind.google/blog/rt-2-new-model-translates-vision-and-language-into-action/",
    "organization": "Google DeepMind",
    "date": "July 28, 2023",
    "documentTitle": "RT-2"
  },
  {
    "label": "Helix 02",
    "url": "https://www.figure.ai/news/helix-02",
    "organization": "Figure AI",
    "date": "2026",
    "documentTitle": "Helix 02"
  },
  {
    "label": "Redwood AI",
    "url": "https://www.1x.tech/discover/redwood-ai",
    "organization": "1X Technologies",
    "date": "accessed July 11, 2026",
    "documentTitle": "Redwood AI"
  },
  {
    "label": "Skild Brain",
    "url": "https://www.skild.ai/blogs/building-the-general-purpose-robotic-brain",
    "organization": "Skild AI",
    "date": "accessed July 11, 2026",
    "documentTitle": "Skild Brain"
  },
  {
    "label": "Open X-Embodiment repository",
    "url": "https://github.com/google-deepmind/open_x_embodiment",
    "organization": "Google DeepMind and collaborators",
    "date": "accessed July 11, 2026",
    "documentTitle": "Open X-Embodiment repository"
  },
  {
    "label": "Official openpi repository",
    "organization": "Physical Intelligence",
    "documentTitle": "openpi model releases and checkpoints",
    "date": "Accessed October 11, 2026",
    "url": "https://github.com/Physical-Intelligence/openpi"
  }
],
    "internalLinks": [
      {
        "label": "Use the autonomy and teleoperation evidence checklist",
        "path": "/robotics-news/autonomous-vs-teleoperated-robot-guide"
      },
      {
        "label": "See how Physical AI is evaluated in factory deployments",
        "path": "/robotics-news/humanoid-factory-deployments"
      },
      {
        "label": "Compare the models and hardware inside four humanoid platforms",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      },
      {
        "label": "Review household tasks demonstrated by robot policies",
        "path": "/robotics-news/what-home-robots-can-do"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "A layered diagram from robot sensors through reasoning, world modeling, action policy and motor control.",
        "alt": "Physical AI model stack connecting perception, reasoning, planning, action and control",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      },
      {
        "type": "Secondary image",
        "caption": "NVIDIA Isaac GR00T development pipeline from teleoperation and simulation to deployment.",
        "alt": "NVIDIA Isaac GR00T workflow for humanoid data, policy training and robot deployment",
        "source": "NVIDIA",
        "sourceUrl": "https://developer.nvidia.com/blog/develop-humanoid-robot-policies-end-to-end-with-nvidia-isaac-gr00t/"
      },
      {
        "type": "Secondary image",
        "caption": "Gemini Robotics performing dexterous manipulation on supported robot hardware.",
        "alt": "Robot controlled by Gemini Robotics manipulating household objects",
        "source": "Google DeepMind",
        "sourceUrl": "https://deepmind.google/models/gemini-robotics/"
      },
      {
        "type": "Secondary image",
        "caption": "Physical Intelligence π0 policy operating multiple robot embodiments.",
        "alt": "Physical Intelligence pi-zero generalist robot policy on several robot platforms",
        "source": "Physical Intelligence",
        "sourceUrl": "https://physicalintelligence.company/blog/pi0"
      },
      {
        "type": "Original chart",
        "caption": "Open-access matrix for code, weights, data and commercial license.",
        "alt": "Physical AI model openness matrix comparing code, weights, training data and licenses",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "GR00T 1.7, Gemini Robotics-ER 1.6 and current access states are tied to official pages.",
        "World models, simulators and action policies are separated by output role.",
        "Open access is split into code, weights, data and license."
      ],
      "unconfirmed": [
        "Training dataset composition is incomplete for several closed models.",
        "No common real-robot benchmark covers every model in the catalog.",
        "Independent reproduction of proprietary home and humanoid policies is unavailable."
      ],
      "fastChanging": [
        "Model versions, licenses, preview access and public checkpoints can change within weeks."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "humanoid-factory-deployments",
    "slug": "humanoid-factory-deployments",
    "path": "/robotics-news/humanoid-factory-deployments",
    "title": "Humanoid Factory Deployments Real, Pilot or Announced?",
    "headline": "Humanoid Robots in Factories Commercial Work, Pilots and Announcements",
    "seoTitle": "Humanoid Factory Deployments Real, Pilot or Announced?",
    "description": "A verified database of humanoid factory and warehouse projects, separating commercial deployments, pilots, internal tests, demos and partnerships.",
    "category": "Industrial deployments",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "18 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "humanoid factory deployments",
    "keywords": [
      "humanoid robots in factories",
      "Figure BMW deployment",
      "Agility Digit GXO",
      "Apptronik Mercedes pilot",
      "UBTECH Walker factory",
      "Atlas Hyundai deployment",
      "humanoid warehouse robots",
      "factory robot pilot"
    ],
    "searchQuestions": [
      "Which humanoid robots work in factories?",
      "Was Figure deployed at BMW?",
      "Is Digit commercially deployed?",
      "Does Amazon use humanoid robots?",
      "Which factory humanoid claims are only pilots?"
    ],
    "longTailKeywords": [
      "verified humanoid robot factory deployments",
      "commercial humanoid deployments versus pilots",
      "BMW Figure robot production evidence",
      "humanoid robots in automotive factories 2026"
    ],
    "entities": [
      "BMW",
      "Mercedes-Benz",
      "Amazon",
      "GXO",
      "Magna",
      "Schaeffler",
      "Hyundai",
      "Foxconn",
      "BYD",
      "NIO",
      "Dongfeng",
      "Geely",
      "UBTECH",
      "Figure AI",
      "Apptronik",
      "Agility Robotics",
      "Tesla",
      "AgiBot",
      "Unitree"
    ],
    "introduction": [
      "Figure 02 spent 1,250 hours at BMW Group Plant Spartanburg and loaded more than 90,000 sheet-metal parts, according to Figure’s November 2025 report. Agility says Digit has accumulated more than 65,000 operating hours across nine customer facilities and names GXO, Schaeffler, Toyota Motor Manufacturing Canada and Mercado Libre as commercial customers. Those are stronger records than a partnership announcement or a robot filmed once beside a production line.",
      "This database assigns an evidence status to each case, distinguishing recurring deployment, pilots, internal tests, training facilities, demonstrations, announcements and insufficiently supported claims. The status follows the available proof, not the most ambitious wording in a press release. A factory video is not enough by itself. The record needs a named site or customer, task, date and evidence of duration, recurring work, transaction or integration. Where robot count, shift schedule, autonomy or payment terms remain private, the table says so."
    ],
    "keyFindings": [
      "Figure’s completed Figure 02 BMW program has the most detailed public task metrics among biped factory deployments reviewed.",
      "Agility provides the broadest current commercial-customer evidence, including operating hours and multiple named facilities.",
      "Apptronik’s Mercedes-Benz program is a pilot even though the release uses “commercial agreement.”",
      "UBTECH documents many Chinese automotive and manufacturing trials, but most pages omit fleet size, duration and independent operating data.",
      "Boston Dynamics opened the RMAC training center at Hyundai Motor Group Metaplant America on September 21, 2026; Hyundai’s production-line Atlas deployment is planned to begin in 2028."
    ],
    "comparisonTables": [
      {
        "id": "factory-deployment-database",
        "title": "Verified humanoid factory and warehouse cases",
        "description": "Status is based on evidence rechecked September 26, 2026. Company-reported metrics are labeled as such.",
        "columns": [
          "Robot / company",
          "Client and site",
          "Task and date",
          "Evidence",
          "Status",
          "Autonomy"
        ],
        "rows": [
          [
            "Figure 02 / Figure AI",
            "BMW Group Plant Spartanburg, South Carolina, USA",
            "Sheet-metal part loading; 11-month program reported November 2025",
            "90,000+ parts, 1,250+ hours, weekday 10-hour shifts and stated KPIs; company report",
            "Commercial deployment",
            "Supervised autonomous; intervention target stated, achieved rate not fully published"
          ],
          [
            "Figure 03 / Figure AI",
            "BMW Group, named logistics workflow",
            "Parts handling and cart pulling; June 2026 update",
            "Official deployment update, but shorter public operating history than Figure 02",
            "Technical pilot / early deployment",
            "Autonomous classification claimed by Figure; intervention data limited"
          ],
          [
            "Digit / Agility Robotics",
            "GXO facility, Georgia, USA",
            "Tote movement in logistics; multi-year RaaS announced 2024",
            "Commercial agreement and repeated tote-moving claims; company says more than 100,000 totes",
            "Commercial deployment",
            "Supervised autonomous with Agility Arc fleet management"
          ],
          [
            "Digit / Agility Robotics",
            "Toyota Motor Manufacturing Canada",
            "Manufacturing, supply chain and logistics tasks; commercial agreement February 2026 after pilot",
            "Official RaaS agreement following a successful pilot",
            "Commercial deployment",
            "Supervised autonomous; fleet size not disclosed"
          ],
          [
            "Digit / Agility Robotics",
            "Schaeffler facilities",
            "Material movement; agreement announced November 2024",
            "Customer investment and intended purchase; later Agility materials call current operations commercial",
            "Commercial deployment",
            "Supervised autonomous; site-level task and count not public"
          ],
          [
            "Digit / Agility Robotics",
            "Mercado Libre, San Antonio, Texas",
            "Fulfillment support; agreement December 2025",
            "Commercial agreement and named facility; unit count not disclosed",
            "Commercial deployment",
            "Supervised autonomous"
          ],
          [
            "Digit / Agility Robotics",
            "Amazon research facility",
            "Tote recycling / material movement tests",
            "Officially named by Agility as customer or deployment partner; current fleet detail limited",
            "Technical pilot",
            "Supervised autonomous"
          ],
          [
            "Apollo / Apptronik",
            "Mercedes-Benz manufacturing facilities",
            "Kitted-parts delivery and component inspection; announced March 2024",
            "Official agreement explicitly says pilot and exploration",
            "Paid pilot or technical pilot; payment not disclosed",
            "Human-in-the-loop / supervised autonomous; exact mode not published"
          ],
          [
            "Apollo / Apptronik",
            "Jabil manufacturing operations",
            "Build, test and deploy Apollo; announced 2025",
            "Strategic manufacturing and pilot partnership; site metrics not public",
            "Technical pilot / announced scaling partnership",
            "Autonomy not disclosed"
          ],
          [
            "Atlas / Boston Dynamics",
            "Robotics Metaplant Application Center at Hyundai Motor Group Metaplant America, Georgia, USA",
            "Training and validation for parts sequencing; RMAC opened September 21, 2026",
            "Boston Dynamics says Atlas robots are in training at RMAC; Hyundai says production-line deployment at HMGMA is planned to begin in 2028",
            "Training / pre-deployment validation",
            "Production-line autonomy and intervention data not yet published"
          ],
          [
            "Optimus / Tesla",
            "Tesla internal factories",
            "Material handling and internal tasks; recurring company demonstrations",
            "No external customer, audited hours or stable fleet count published",
            "Internal test",
            "Autonomy not disclosed per clip"
          ],
          [
            "Walker S / UBTECH",
            "NIO advanced manufacturing base F2, China",
            "Final assembly and quality inspection",
            "Official UBTECH case page; duration, count and shift data absent",
            "Technical pilot",
            "Autonomy not disclosed in enough detail"
          ],
          [
            "Walker S1 / UBTECH",
            "BYD factory, China",
            "Handling and coordination with AMRs/AGVs",
            "Official case page describes one-stop autonomous logistics application",
            "Technical pilot",
            "Supervised autonomous claim; independent evidence absent"
          ],
          [
            "Walker S Lite / UBTECH",
            "Zeekr / Geely smart warehouse, China",
            "Parcel-tote handling and CTU loading; three weeks of training",
            "Named site and training duration on official page",
            "Technical pilot",
            "Autonomy not disclosed"
          ],
          [
            "Walker S / UBTECH",
            "Dongfeng Liuzhou Motor, China",
            "Inspection, fluid filling and emblem application",
            "Official page lists tasks but no operating duration or count",
            "Demonstration / technical pilot",
            "Autonomy not disclosed"
          ],
          [
            "Walker S2 / UBTECH",
            "SANY RE wind-power smart factory, China",
            "Bolt-sleeve removal, sorting, tray transfer and assembly collaboration",
            "Official industrial-solution page; fleet and shift metrics absent",
            "Technical pilot",
            "Supervised autonomous claim"
          ],
          [
            "Walker S2 plus logistics robots / UBTECH",
            "Foxconn New Energy Vehicle R&D Centre, China",
            "SPS parts feeding for Chitu α production validation",
            "Official multi-agent collaboration description",
            "Technical pilot",
            "Supervised autonomous / coordinated system"
          ],
          [
            "Phoenix / Sanctuary AI",
            "Magna automotive operations",
            "Inspection, assembly and general manufacturing work",
            "Strategic investment and development partnership; detailed live shift data not public",
            "Announced partnership / technical pilot",
            "Piloted, autonomous or hybrid depending on task"
          ],
          [
            "AgiBot humanoids",
            "Multiple Chinese industrial customers claimed",
            "Material handling and inspection",
            "Production and deployment claims exist, but case-level hours and intervention data are limited",
            "Deployment claim without sufficient evidence",
            "Autonomy not disclosed"
          ],
          [
            "Unitree humanoids",
            "Factory demonstrations and customer trials",
            "Handling, inspection and demonstrations",
            "Public videos and sales material do not establish a single audited recurring deployment in this review",
            "Demonstration / insufficient evidence",
            "Varies; often not disclosed"
          ]
        ]
      }
    ],
    "sections": [
      {
        "heading": "A commercial deployment needs recurring work and a customer relationship",
        "paragraphs": [
          "The strongest evidence combines a named customer, integrated workflow, recurring schedule and transaction. Figure’s BMW report includes runtime, part count, shift pattern and task KPIs. Agility’s GXO relationship is described as a multi-year Robots-as-a-Service deployment, and later company material adds broader operating hours across customer facilities. These disclosures still come from suppliers, but they contain enough operational detail to distinguish work from a trade-show demonstration.",
          "A paid pilot can also be commercially meaningful without being a deployment. Apptronik and Mercedes-Benz explicitly frame Apollo as a pilot to explore parts delivery and inspection. Calling it a commercial agreement does not erase the pilot status. The robot is being evaluated before broad production use."
        ]
      },
      {
        "heading": "Generation and task changes reset the evidence",
        "paragraphs": [
          "Figure 02’s BMW metrics cannot be copied onto Figure 03. The newer robot uses different hardware and a new logistics workflow. Figure 02 was retired after the program, so its 1,250 hours prove that generation and task. Figure 03 needs its own observation period, success metrics and intervention record.",
          "The same rule applies when a company changes hands, end effectors, wheels, software or customer site. A model name alone is not a stable test condition. Every database row should preserve robot generation, date, task and location."
        ]
      },
      {
        "heading": "Chinese factory activity is broad but unevenly documented",
        "paragraphs": [
          "UBTECH’s official industrial page names NIO, BYD, Geely/Zeekr, Dongfeng, FAW-Volkswagen, SANY RE and Foxconn-related workflows. The tasks are concrete tote handling, quality inspection, fluid filling, emblem application, bolt sorting and parts feeding. This is stronger than an unnamed “automotive customer” claim.",
          "The missing fields are equally important. Most cases do not publish fleet size, autonomous cycle count, intervention rate, daily schedule or commercial payment terms. They should be classified as technical pilots unless later documents establish recurring paid operations."
        ]
      },
      {
        "heading": "Internal tests are valuable but not customer deployments",
        "paragraphs": [
          "Tesla can iterate Optimus inside its own factories without a sales contract. Internal use can generate real data and expose the robot to production constraints. It does not demonstrate external integration, service support, warranty or customer acceptance. An internal fleet should therefore remain a separate status even when the environment is a working factory.",
          "Boston Dynamics now has Atlas robots training at its Robotics Metaplant Application Center inside Hyundai Motor Group Metaplant America. That establishes pre-deployment training on parts sequencing, while Hyundai's production-line Atlas deployment remains planned for 2028."
        ]
      },
      {
        "heading": "Autonomy must be attached to the exact task",
        "paragraphs": [
          "A robot may autonomously walk between stations while a person teleoperates manipulation. Another may execute a learned policy while an operator approves each cycle. Sanctuary explicitly says its robots can run piloted, autonomous or hybrid modes. A deployment database should never assign one autonomy label to an entire company.",
          "Useful records include the intervention trigger, remote-operator role, number of completed cycles and recovery behavior. Most announcements omit these fields. “Autonomy not disclosed” is more accurate than guessing from smooth video."
        ]
      }
    ],
    "limitations": [
      "Most deployment metrics are supplier-reported and not independently audited.",
      "Customer confidentiality often hides robot count, contract value, intervention rate and shift performance.",
      "The word deployment is used inconsistently by companies, from a one-week pilot to recurring paid work.",
      "A named factory and task do not prove daily operation unless duration or schedule is published.",
      "The database is a verified snapshot dated September 26, 2026; programs can move between pilot, training and commercial status as new operating evidence appears."
    ],
    "conclusion": [
      "Commercial humanoid work exists, but it is concentrated in a small number of bounded material-handling workflows. Figure 02 at BMW and Digit across Agility’s named customers provide the strongest public operating records. They show why early deployments focus on totes, parts and repetitive transport objects, stations and cycle requirements can be defined, and a human workforce remains nearby.",
      "Most other factory programs remain lower in the evidence ladder. Apollo at Mercedes-Benz is a pilot. Atlas is in pre-deployment training at Hyundai's RMAC, with production-line use planned for 2028. Tesla Optimus remains an internal program. UBTECH has broad named factory trials but limited published fleet and shift data. Magna and Sanctuary describe a development partnership whose operating details remain incomplete. Announcements, technical pilots, training programs and recurring commercial work are kept in separate columns."
    ],
    "faqs": [
      {
        "question": "Are humanoid robots already working in factories?",
        "answer": "Yes, but the verified work is narrow. Figure 02 loaded sheet-metal parts at BMW, and Agility Digit moves totes and materials for named customers. Many other programs remain pilots, internal tests or announced deployments. No evidence supports the claim that general humanoids broadly replace factory workers across unrestricted tasks."
      },
      {
        "question": "Was Figure 02 commercially deployed at BMW?",
        "answer": "Figure reports an 11-month BMW program with more than 1,250 runtime hours, 90,000 parts loaded and weekday 10-hour shifts. That is strong deployment evidence for Figure 02 on one sheet-metal loading task. The figures are company-reported, and they should not be transferred to Figure 03 or other tasks."
      },
      {
        "question": "Is Agility Digit commercially deployed?",
        "answer": "Agility identifies GXO, Schaeffler, Toyota Motor Manufacturing Canada and Mercado Libre as commercial customers and reports operations across nine facilities. GXO began as a multi-year Robots-as-a-Service agreement. Exact fleet size, customer-level hours and intervention data are not fully public, but the evidence is stronger than a standalone pilot announcement."
      },
      {
        "question": "Does Amazon use humanoid robots?",
        "answer": "Amazon has tested Agility Digit in logistics workflows, and Agility continues to name Amazon among its customers or partners. Public information does not provide a current broad fleet count or enough site-level evidence to classify Amazon as a large recurring commercial deployment. This database records it as a technical pilot."
      },
      {
        "question": "Are UBTECH robots deployed at Chinese car factories?",
        "answer": "UBTECH officially names trials or applications at NIO, BYD, Geely/Zeekr, Dongfeng and other sites. The tasks are specific, but public pages often omit robot count, daily operating schedule, intervention rate and payment terms. Most cases therefore qualify as technical pilots rather than proven recurring commercial deployments."
      },
      {
        "question": "How can a factory deployment be verified?",
        "answer": "Look for a named robot generation, customer, site, task, start date, duration, fleet size, schedule, autonomy mode and operating metric. A contract or customer statement strengthens the case. Edited video without those fields may show capability, but it cannot establish routine paid production work."
      }
    ],
    "methodology": [
      "Each case was checked against official supplier or customer pages. Evidence was assigned to the stated categories, with mixed situations described in the individual rows. Commercial deployment requires recurring work and a commercial relationship; a named pilot remains a pilot even when announced under a commercial agreement.",
      "Verified September 26, 2026. Metrics remain company-reported unless the source identifies independent validation. Missing counts, contract values and autonomy data are stated explicitly."
    ],
    "sourceLinks": [
      {
        "label": "F.02 Contributed to the Production of 30,000 Cars at BMW",
        "url": "https://www.figure.ai/news/production-at-bmw",
        "organization": "Figure AI",
        "date": "November 19, 2025",
        "documentTitle": "F.02 Contributed to the Production of 30,000 Cars at BMW"
      },
      {
        "label": "Figure 03 at BMW",
        "url": "https://www.figure.ai/news/f-03-at-bmw",
        "organization": "Figure AI",
        "date": "June 30, 2026",
        "documentTitle": "Figure 03 at BMW"
      },
      {
        "label": "Agility Robotics commercial record",
        "url": "https://www.agilityrobotics.com/content/agility-robotics-to-go-public-through-merger-with-churchill-capital-corp-xi",
        "organization": "Agility Robotics",
        "date": "June 24, 2026",
        "documentTitle": "Agility Robotics commercial record"
      },
      {
        "label": "Toyota Motor Manufacturing Canada agreement",
        "url": "https://www.agilityrobotics.com/content/agility-robotics-announces-commercial-agreement-with-toyota-motor-manufacturing-canada",
        "organization": "Agility Robotics",
        "date": "February 19, 2026",
        "documentTitle": "Toyota Motor Manufacturing Canada agreement"
      },
      {
        "label": "Mercado Libre commercial agreement",
        "url": "https://www.agilityrobotics.com/content/mercado-libre-and-agility-robotics-announce-commercial-agreement",
        "organization": "Agility Robotics",
        "date": "December 10, 2025",
        "documentTitle": "Mercado Libre commercial agreement"
      },
      {
        "label": "Schaeffler investment and deployment agreement",
        "url": "https://www.agilityrobotics.com/content/agility-robotics-announces-strategic-investment-and-agreement-with-motion-technology-company-schaeffler-group",
        "organization": "Agility Robotics",
        "date": "November 13, 2024",
        "documentTitle": "Schaeffler investment and deployment agreement"
      },
      {
        "label": "Apptronik and Mercedes-Benz commercial agreement",
        "url": "https://apptronik.com/company/press-releases-collection/apptronik-and-mercedes-benz-enter-commercial-agreement",
        "organization": "Apptronik",
        "date": "March 15, 2024",
        "documentTitle": "Apptronik and Mercedes-Benz commercial agreement"
      },
      {
        "label": "Atlas industrial humanoid",
        "url": "https://bostondynamics.com/products/atlas/",
        "organization": "Boston Dynamics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Atlas industrial humanoid"
      },
      {
        "label": "Enterprise Robotics, Redefined",
        "url": "https://bostondynamics.com/blog/enterprise-robotics-redefined/",
        "organization": "Boston Dynamics",
        "date": "2026",
        "documentTitle": "Enterprise Robotics, Redefined"
      },
      {
        "label": "UBTECH industrial application solution",
        "url": "https://www.ubtrobot.com/en/humanoid/solutions/industry",
        "organization": "UBTECH Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "UBTECH industrial application solution"
      },
      {
        "label": "Sanctuary AI and Magna development partnership",
        "url": "https://sanctuary.ai/news/a-transformational-few-months-for-sanctuary-ai/",
        "organization": "Sanctuary AI",
        "date": "2024",
        "documentTitle": "Sanctuary AI and Magna development partnership"
      },
      {
        "label": "Sanctuary AI operation modes",
        "url": "https://sanctuary.ai/news/honesty-in-technology-communications-marketing-and-storytelling/",
        "organization": "Sanctuary AI",
        "date": "June 19, 2026",
        "documentTitle": "Sanctuary AI operation modes"
      },
      {
        "label": "Tesla AI and Robotics",
        "url": "https://www.tesla.com/AI",
        "organization": "Tesla",
        "date": "accessed July 11, 2026",
        "documentTitle": "Tesla AI and Robotics"
      }
    ],
    "internalLinks": [
      {
        "label": "Check whether a robot video is autonomous or teleoperated",
        "path": "/robotics-news/autonomous-vs-teleoperated-robot-guide"
      },
      {
        "label": "Compare US and Chinese production evidence",
        "path": "/robotics-news/china-vs-usa-humanoid-robot-production"
      },
      {
        "label": "Explore the Physical AI models behind robot policies",
        "path": "/robotics-news/physical-ai-model-map"
      },
      {
        "label": "Compare Tesla Optimus, Figure 03, Unitree G1 and NEO",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "A verified factory deployment matrix using official photos from BMW, GXO, Mercedes-Benz, Hyundai and UBTECH cases.",
        "alt": "Humanoid robots working in automotive and logistics facilities with deployment-status labels",
        "source": "Official company media",
        "sourceUrl": "https://www.figure.ai/news/production-at-bmw"
      },
      {
        "type": "Secondary image",
        "caption": "Figure 02 loading sheet-metal parts at BMW Plant Spartanburg.",
        "alt": "Figure 02 humanoid robot loading sheet metal at BMW Group Plant Spartanburg",
        "source": "Figure AI",
        "sourceUrl": "https://www.figure.ai/news/production-at-bmw"
      },
      {
        "type": "Secondary image",
        "caption": "Digit moving totes in a commercial logistics workflow.",
        "alt": "Agility Robotics Digit carrying a tote in a logistics facility",
        "source": "Agility Robotics",
        "sourceUrl": "https://www.agilityrobotics.com/"
      },
      {
        "type": "Secondary image",
        "caption": "Walker robot in a named Chinese automotive manufacturing task.",
        "alt": "UBTECH Walker humanoid robot working at an automotive factory station",
        "source": "UBTECH Robotics",
        "sourceUrl": "https://www.ubtrobot.com/en/humanoid/solutions/industry"
      },
      {
        "type": "Original chart",
        "caption": "Evidence ladder from demonstration to commercial deployment.",
        "alt": "Humanoid factory evidence ladder covering demo, internal test, pilot, partnership and commercial deployment",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "September 26, 2026",
      "confirmed": [
        "Figure 02 BMW metrics retain the exact generation and reported program duration.",
        "Agility’s commercial agreements are separated from pilots and scheduled deployments.",
        "UBTECH cases are classified conservatively where fleet and shift data are missing."
      ],
      "unconfirmed": [
        "Payment terms and robot counts remain private for most factory programs.",
        "AgiBot and Unitree recurring customer deployment claims lack sufficient case-level data in the reviewed primary pages.",
        "Tesla’s current internal fleet size and intervention rate are not public."
      ],
      "fastChanging": [
        "Atlas is now in pre-deployment training at Hyundai's RMAC; production-line operation remains planned for 2028, while other pilots may change status as new operating evidence appears."
      ]
    },
    "schemaType": "Article"
  },
  {
    "id": "cheapest-humanoid-robots",
    "slug": "cheapest-humanoid-robots",
    "path": "/robotics-news/cheapest-humanoid-robots",
    "title": "The Cheapest Humanoid Robots Available Today",
    "headline": "The Lowest-Priced Humanoid Robots You Can Actually Order",
    "seoTitle": "Cheapest Humanoid Robots Available to Buy Today in 2026",
    "description": "Verified humanoid robot prices from official stores, with categories, shipping status, included hardware, deposits, subscriptions and hidden costs.",
    "category": "Buying guide",
    "datePublished": "2026-07-11",
    "dateModified": "2026-10-11",
    "readingTime": "16 min read",
    "authorName": "TechniaHQRobot",
    "authorHandle": "@techniahqrobot",
    "primaryKeyword": "cheapest humanoid robots",
    "keywords": [
      "cheap humanoid robot",
      "humanoid robot price",
      "Unitree R1 price",
      "Booster K1 price",
      "Unitree G1 price",
      "ROBOTIS OP3 price",
      "Reachy Mini price",
      "1X NEO price",
      "humanoid robot for sale"
    ],
    "searchQuestions": [
      "What is the cheapest humanoid robot?",
      "Can I buy a humanoid robot today?",
      "How much does Unitree R1 cost?",
      "Is the NEO deposit the full price?",
      "What costs are excluded from a humanoid price?"
    ],
    "longTailKeywords": [
      "cheapest complete humanoid robot for sale",
      "humanoid development platform prices 2026",
      "small educational humanoid robot price",
      "robots available to buy with official pricing"
    ],
    "entities": [
      "Unitree R1",
      "Unitree R1-D",
      "Booster K1",
      "Unitree G1",
      "ROBOTIS OP3",
      "Reachy Mini",
      "1X NEO",
      "Weave Isaac",
      "Unitree H2"
    ],
    "introduction": [
      "Unitree's official store currently lists R1-D from $4,290 and the R1 family from $4,900. The R1 product page identifies the $4,900 configuration as R1 Air and lists R1 at $5,900. Pollen Robotics lists Reachy Mini Lite at €350 and Reachy Mini Wireless at €435, but both are desktop robots rather than walking humanoids.",
      "1X requires a $200 deposit for NEO, while the published Early Access ownership price is $20,000 or $499 per month. Booster's current official purchase page routes K1 buyers to a sales inquiry and does not display a manufacturer price, so K1 is no longer assigned a current public total in this guide. Taxes, freight, duties, optional hands, compute and support can change delivered cost."
    ],
    "keyFindings": [
      "Unitree R1-D starts at $4,290; the R1 product page lists R1 Air at $4,900 and R1 at $5,900.",
      "Booster's current official purchase page does not display a K1 price and routes buyers through a sales inquiry.",
      "Unitree G1 remains publicly listed from $13,500, while dexterous hands, EDU features and expanded compute can raise the total.",
      "Pollen Robotics currently lists Reachy Mini Lite at €350 and Wireless at €435; both are desktop robots without walking legs.",
      "NEO's $200 payment is a deposit; 1X lists Early Access ownership at $20,000 or a $499 monthly subscription."
    ],
    "comparisonTables": [
      {
        "id": "verified-humanoid-prices",
        "title": "Humanoid and humanoid-style robots with verifiable prices",
        "description": "Prices are manufacturer or official-store base listings rechecked on September 26, 2026. Currency conversion is avoided because exchange rates change.",
        "columns": [
          "Product and category",
          "Base price",
          "What the listing includes",
          "Availability / region",
          "Major exclusions or caveats"
        ],
        "rows": [
          [
            "Reachy Mini Lite; desktop upper-body kit",
            "€350",
            "DIY structure, nine servos, camera, microphones, speaker and USB connection; external computer required",
            "Official Pollen Robotics store; lead time up to 90 days",
            "No arms or locomotion; VAT, shipping and import duties excluded"
          ],
          [
            "Reachy Mini Wireless; desktop upper-body kit",
            "€435",
            "DIY kit plus onboard compute and wireless operation",
            "Official store; lead time up to 90 days",
            "No arms or legs; VAT, freight and duties added at checkout"
          ],
          [
            "Unitree R1-D; complete compact biped / development listing",
            "From $4,290",
            "Base robot configuration as listed by Unitree",
            "Official Unitree store; order channel available",
            "Exact configuration, hands, compute, shipping, tax and support vary by quote or checkout"
          ],
          [
            "Unitree R1 Air; complete compact biped",
            "$4,900",
            "R1 Air configuration on Unitree's official R1 page",
            "Official Unitree sales channel",
            "R1 is listed separately at $5,900; customization, freight, tax and application software can add cost"
          ],
          [
            "Booster K1; small educational / development biped",
            "Quote required",
            "K1 product and developer platform",
            "Official Booster purchase inquiry",
            "The current manufacturer purchase page does not display a public total price"
          ],
          [
            "ROBOTIS OP3; small research humanoid",
            "$13,764.35",
            "Complete OP3 platform through the US store",
            "Add-to-cart listing in the United States",
            "Shipping calculated at checkout; small research robot, not human-scale labor platform"
          ],
          [
            "Unitree G1; compact research humanoid",
            "$13,500",
            "Base 23-DOF robot, depth camera, 3D LiDAR and standard battery",
            "Official Unitree store and sales channel",
            "Base model lacks dexterous hands; tax, freight, EDU features and hand options are extra"
          ],
          [
            "1X NEO; full-size home humanoid",
            "$20,000 Early Access ownership or $499/month",
            "$200 refundable deposit reserves access; product includes home robot and service terms per offer",
            "US delivery program planned for 2026",
            "Deposit is not full price; Expert Mode, subscription terms, taxes, delivery and availability require contract review"
          ],
          [
            "Unitree H2; full-size humanoid",
            "$29,900",
            "Base H2 platform listing",
            "Official Unitree store / contact channel",
            "Final configuration, hands, software, tax, shipping and support not fully represented by headline price"
          ],
          [
            "Unitree H1; full-size research/industrial humanoid",
            "$90,000 store reference with instruction to contact for real price",
            "H1 platform subject to sales configuration",
            "Contact sales",
            "Displayed figure is not a firm final quote; options, freight and service vary"
          ],
          [
            "Unitree H2 Plus; full-size high-spec humanoid",
            "$100,000",
            "Higher-spec H2 configuration",
            "Official store listing",
            "Application integration, freight, taxes, support and optional equipment may be additional"
          ],
          [
            "Weave Isaac 0; stationary home laundry robot",
            "$249/month or $3,999 plus $49/month",
            "Robot/service program focused on laundry",
            "Limited California order program; estimated 4-6 weeks on reviewed page",
            "Not a mobile humanoid; ongoing service fee, region and home setup apply"
          ],
          [
            "Weave Isaac 1; mobile home robot",
            "$449/month or $7,999 plus optional $99/month premium",
            "$250 refundable reservation toward fall-2026 California program",
            "California first, wider US planned later",
            "Reservation is not delivery; mobile platform is wheeled and final service terms can change"
          ]
        ]
      },
      {
        "id": "announced-not-shipping",
        "title": "Announced products that should not enter a “cheapest available” ranking",
        "description": "A deposit, target price or factory cost is not a verifiable delivered-product price.",
        "columns": [
          "Product",
          "Public number",
          "Why it is excluded from the main ranking"
        ],
        "rows": [
          [
            "Sunday Memo",
            "About $20,000 current hand-built cost; company expects lower retail price",
            "Not for purchase until after the late-2026 beta; manufacturing cost is not retail price"
          ],
          [
            "Tesla Optimus",
            "No official current sale price",
            "Executive targets and media estimates are not a checkout price"
          ],
          [
            "Figure 03",
            "No public price",
            "Enterprise access only; no retail order page"
          ],
          [
            "Boston Dynamics Atlas",
            "Contact / enterprise relationship",
            "2026 customer program, no public unit price"
          ],
          [
            "Apptronik Apollo",
            "No public price",
            "Pilots and commercial agreements do not publish a standard purchase price"
          ],
          [
            "Fauna Sprout",
            "Request-based commercial channel",
            "No current public list price reviewed"
          ],
          [
            "K-Scale K-Bot or Z-Bot",
            "Historic project information",
            "Current official shipping and active sales status not confirmed"
          ]
        ]
      }
    ],
    "sections": [
      {
        "heading": "The cheapest complete bipeds are development platforms",
        "paragraphs": [
          "Unitree R1-D and R1 reach unusually low public headline prices by targeting development and embodied-AI experimentation. Booster K1 belongs in a similar development category, but Booster's current official sales path requires an inquiry rather than displaying a public price. The buyer receives hardware and a software starting point, not a robot trained to perform a commercial job. Application development, data collection, safety validation and maintenance remain the buyer’s responsibility.",
          "A lower price can also reflect smaller size, lighter payload, simpler hands or reduced onboard compute. Those tradeoffs are acceptable for locomotion research and classroom work. They become expensive when a project later needs dexterous manipulation, high-torque joints, industrial certification or continuous service."
        ]
      },
      {
        "heading": "G1 costs $13,500 before the useful options",
        "paragraphs": [
          "Unitree’s base G1 listing is transparent about the starting price and core body specifications. The standard configuration does not include the advanced dexterous hands used in many manipulation demonstrations. EDU configurations can add development access, compute and hand options. Freight and taxes are also outside the headline price.",
          "The correct budget is therefore the configured robot delivered to the laboratory, not the base page. A buyer should request a bill of materials covering hands, batteries, charger, controller, compute, SDK access, spare actuators, fall protection, shipping, duty and support."
        ]
      },
      {
        "heading": "Small research humanoids are not cheaper versions of factory robots",
        "paragraphs": [
          "ROBOTIS OP3 is a compact research platform with an established DYNAMIXEL ecosystem, ROS support and decades of small-humanoid use. Its cited US store price exceeds the cited R1 listings despite the smaller body; the table does not establish a comparable public K1 price. Price reflects ecosystem, actuators, support channel and product history, not only height or payload.",
          "Reachy Mini belongs in an upper-body desktop category. It offers expressive head motion, vision and audio at a consumer-accessible price, but it has no arms or locomotion. Calling it the cheapest humanoid without that qualifier would mislead a reader expecting a mobile manipulator."
        ]
      },
      {
        "heading": "Deposits and subscriptions must be expanded to total cost",
        "paragraphs": [
          "NEO’s $200 is refundable reservation money, not the robot price. The same page publishes $20,000 Early Access ownership and a $499 monthly option. The monthly route may include service conditions that affect total cost, access and ownership. A fair comparison records the deposit, full price and recurring plan separately.",
          "Weave follows a service model. Isaac 0 can be subscribed to or purchased with an ongoing monthly fee, while Isaac 1 offers subscription and upfront options. These products are narrower household systems and have regional launch limits, but their published terms show how robot pricing may shift from equipment purchase to managed service."
        ]
      },
      {
        "heading": "What the advertised price does not include",
        "paragraphs": [
          "The missing items commonly include VAT or sales tax, international freight, customs duty, brokerage, insurance, installation, local certification and payment fees. Humanoid shipping can require crates, dangerous-goods handling for batteries and specialized delivery. A $5,000 robot can acquire a much larger landed cost outside its home market.",
          "Technical costs include dexterous hands, force-torque sensors, tactile arrays, extra batteries, chargers, onboard GPUs, remote controllers, software licenses, data-collection tools, spare actuators and fall rigs. Operational costs include integration engineering, operator training, remote supervision, warranty extensions, maintenance, cloud inference and replacement parts. The invoice price is only the first line of the ownership model."
        ]
      },
      {
        "heading": "How to verify an order before paying",
        "paragraphs": [
          "Confirm the exact legal seller, model generation, configuration code, included accessories, incoterms, delivery country, lead time and refund policy. Ask whether the robot can be exported to the destination and whether software, batteries and radio modules are certified. A marketplace listing or distributor page should be matched to the manufacturer’s official channel.",
          "For a preorder, confirm whether the payment is refundable, whether it locks a price and what event triggers the remaining balance. For a subscription, confirm ownership, minimum term, repair response, data access and what happens when service ends."
        ]
      }
    ],
    "limitations": [
      "Official store prices can change without notice and may vary by region or currency.",
      "“From” prices do not define the final configuration, hands, compute or software package.",
      "Delivery status can differ between a cart-enabled page, a preorder and actual inventory.",
      "Warranty and support terms are not standardized across manufacturers.",
      "Landed cost depends on destination taxes, duties, freight and certification and is not estimated here."
    ],
    "conclusion": [
      "The lowest verified headline price for a complete biped in this review is Unitree R1-D from $4,290, followed by the R1 family from $4,900. Booster K1 remains in the development-platform category, but Booster's current official sales page does not publish a total price. These machines can support locomotion, control and embodied-AI work, but the buyer must build the application and often add compute, hands, spares and safety equipment. Unitree G1 at $13,500 offers a more extensively documented research base, while advanced manipulation configurations cost more than the headline figure.",
      "Small systems need their own category. Reachy Mini is inexpensive because it is a desktop expressive kit, and ROBOTIS OP3 is a compact research humanoid with an established ecosystem. NEO’s $200 deposit should never appear in a cheapest-robot ranking as the total price; 1X publishes $20,000 ownership or $499 monthly. The useful buying number is the landed, configured and supported cost, with availability proven by a real order channel rather than a target, deposit or announcement."
    ],
    "faqs": [
      {
        "question": "What is the cheapest complete humanoid robot available?",
        "answer": "Unitree’s official store lists R1-D from $4,290 and R1 from $4,900, making them the lowest-priced complete biped listings found in this review. The prices are starting points. Configuration, shipping, taxes, hands, compute, software access and support can materially increase the delivered project cost."
      },
      {
        "question": "Is Reachy Mini a complete humanoid robot?",
        "answer": "Reachy Mini is a desktop upper-body expressive robot kit with head motion, camera, microphones and speaker. It has no arms or legs, so it should not be compared directly with a mobile biped. It is useful for human-robot interaction and AI experiments, not physical household or factory manipulation."
      },
      {
        "question": "Does Unitree G1 include dexterous hands for $13,500?",
        "answer": "The base G1 configuration does not include the advanced dexterous hands shown in many manipulation projects. EDU configurations and optional hands add capability and cost. Buyers should request a written configuration covering hand model, tactile sensors, compute, SDK access, batteries, charger, shipping, tax and warranty."
      },
      {
        "question": "Can I buy 1X NEO for $200?",
        "answer": "No. The $200 amount is a refundable deposit. 1X publishes a $20,000 Early Access ownership price and a $499 monthly option. Delivery is tied to the company’s 2026 US program. The final agreement should be checked for taxes, delivery, subscription conditions, remote Expert Mode and service coverage."
      },
      {
        "question": "Why is ROBOTIS OP3 more expensive than some larger robots?",
        "answer": "Robot price reflects actuators, ecosystem, documentation, support and production scale, not only body size. OP3 is an established research platform using the ROBOTIS and DYNAMIXEL ecosystem. Newer Chinese bipeds may have lower starting prices while charging separately for options, freight, support or advanced manipulation hardware."
      },
      {
        "question": "What extra costs should a humanoid buyer expect?",
        "answer": "Common additions include tax, freight, import duty, batteries, chargers, hands, tactile sensors, onboard compute, spare actuators, fall protection, software licenses, integration, training and maintenance. Subscription robots can add monthly service and remote-assistance fees. Ask for the full landed configuration before comparing vendors."
      }
    ],
    "methodology": [
      "Only official manufacturer stores, product pages or order pages with a visible current price or defined sales path were used. Prices are preserved in their listed currencies and were rechecked on September 26, 2026. Deposits, subscriptions, upfront ownership prices and request-a-quote products are separated.",
      "Products are categorized by body and intended use. Desktop upper-body robots, stationary home appliances, compact research humanoids and full-size bipeds are not treated as interchangeable."
    ],
    "sourceLinks": [
      {
        "label": "Unitree humanoid robot store collection",
        "url": "https://shop.unitree.com/collections/humanoid-robot",
        "organization": "Unitree Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Unitree humanoid robot store collection"
      },
      {
        "label": "Unitree R1 product page",
        "url": "https://www.unitree.com/R1",
        "organization": "Unitree Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Unitree R1 product page"
      },
      {
        "label": "Unitree G1 product page",
        "url": "https://www.unitree.com/g1/",
        "organization": "Unitree Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Unitree G1 product page"
      },
      {
        "label": "Booster Robotics K1 sales channel",
        "url": "https://www.boosterobotics.com/",
        "organization": "Booster Robotics",
        "date": "accessed September 26, 2026",
        "documentTitle": "Booster Robotics K1 sales channel"
      },
      {
        "label": "ROBOTIS OP3 US store listing",
        "url": "https://www.robotis.us/robotis-op3-us/",
        "organization": "ROBOTIS",
        "date": "accessed July 11, 2026",
        "documentTitle": "ROBOTIS OP3 US store listing"
      },
      {
        "label": "Reachy Mini Lite official store",
        "url": "https://store.pollen-robotics.com/products/reachy-mini-lite-version",
        "organization": "Pollen Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Reachy Mini Lite official store"
      },
      {
        "label": "Reachy Mini Wireless official store",
        "url": "https://store.pollen-robotics.com/products/reachy-mini-wireless-version",
        "organization": "Pollen Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Reachy Mini Wireless official store"
      },
      {
        "label": "Pollen Robotics terms of service",
        "url": "https://store.pollen-robotics.com/policies/terms-of-service",
        "organization": "Pollen Robotics",
        "date": "June 1, 2026",
        "documentTitle": "Pollen Robotics terms of service"
      },
      {
        "label": "1X NEO order page",
        "url": "https://www.1x.tech/order",
        "organization": "1X Technologies",
        "date": "accessed July 11, 2026",
        "documentTitle": "1X NEO order page"
      },
      {
        "label": "Weave Isaac 0 order page",
        "url": "https://www.weaverobotics.com/isaac-0/order",
        "organization": "Weave Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Weave Isaac 0 order page"
      },
      {
        "label": "Weave Isaac 1 order page",
        "url": "https://www.weaverobotics.com/isaac-1/order",
        "organization": "Weave Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Weave Isaac 1 order page"
      },
      {
        "label": "Sunday Memo FAQ and beta status",
        "url": "https://www.sunday.ai/",
        "organization": "Sunday Robotics",
        "date": "accessed July 11, 2026",
        "documentTitle": "Sunday Memo FAQ and beta status"
      }
    ],
    "internalLinks": [
      {
        "label": "Compare four high-profile humanoid platforms and their availability",
        "path": "/robotics-news/tesla-optimus-vs-figure-unitree-1x-neo"
      },
      {
        "label": "See 20 humanoid robots you can actually buy in 2026",
        "path": "/robotics-news/20-humanoid-robots-you-can-actually-buy-2026"
      },
      {
        "label": "Review real home-robot capabilities before buying",
        "path": "/robotics-news/what-home-robots-can-do"
      },
      {
        "label": "Compare sixteen humanoid robot hand systems",
        "path": "/robotics-news/humanoid-robot-hands-compared"
      }
    ],
    "imageRecommendations": [
      {
        "type": "Main image",
        "caption": "Official product lineup ordered by verified base price, with category labels and no generic robot substitutes.",
        "alt": "Cheapest humanoid robots available in 2026 arranged by verified official base price",
        "source": "Official manufacturer product pages",
        "sourceUrl": "https://shop.unitree.com/collections/humanoid-robot"
      },
      {
        "type": "Secondary image",
        "caption": "Unitree R1 official product image with the $4,900 starting-price label.",
        "alt": "Unitree R1 compact biped humanoid robot on a plain background",
        "source": "Unitree Robotics",
        "sourceUrl": "https://www.unitree.com/R1"
      },
      {
        "type": "Secondary image",
        "caption": "Booster K1 official development-platform image.",
        "alt": "Booster K1 small humanoid robot development platform",
        "source": "Booster Robotics",
        "sourceUrl": "https://www.boosterobotics.com/"
      },
      {
        "type": "Secondary image",
        "caption": "Reachy Mini kit components and assembled desktop robot.",
        "alt": "Reachy Mini desktop robot kit with camera, microphones and expressive head",
        "source": "Pollen Robotics",
        "sourceUrl": "https://store.pollen-robotics.com/products/reachy-mini-wireless-version"
      },
      {
        "type": "Original chart",
        "caption": "Stacked landed-cost chart showing base robot, hands, compute, freight, tax, support and integration.",
        "alt": "Humanoid robot total cost chart beyond the advertised base price",
        "source": "TechniaHQRobot original graphic",
        "sourceUrl": "https://www.techniahqservice.com"
      }
    ],
    "factCheck": {
      "verifiedDate": "July 11, 2026",
      "confirmed": [
        "All prices in the main table come from official manufacturer stores or order pages.",
        "The NEO deposit is separated from ownership and monthly pricing.",
        "Reachy Mini is labeled as a desktop upper-body kit rather than a complete mobile humanoid."
      ],
      "unconfirmed": [
        "Final delivered configuration and lead time require vendor confirmation for several “from” listings.",
        "Unitree H1’s displayed store figure is explicitly not presented as a firm final quote.",
        "Regional stock and export eligibility are not independently verified."
      ],
      "fastChanging": [
        "Prices, currency display, inventory, freight and preorder schedules can change without notice."
      ]
    },
    "schemaType": "Article"
  }
];
